
import {
  Component, OnInit, Input, Output, OnChanges, EventEmitter,
  Directive, ViewContainerRef, ViewChildren, ViewChild, QueryList, ComponentFactoryResolver, AfterContentInit, ComponentRef, AfterViewInit, TemplateRef
} from '@angular/core';
import { BusinessunitService } from '../../Master/businessunit/businessunit.service';
//import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Businessunit } from '../../Master/businessunit/businessunit';
import { ProductService } from '../../Master/product/product.service';
import { Product } from '../../Master/product/product';
import $ from 'jquery';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { RequestconfigService } from './requestconfig.service';
import { RequestconfigModel, ConversionrequestDetail, ConversionrequestFileDetail } from '../requestconfig/requestconfig';
import { Database } from '../../Master/database/database';
import { DatabaseService } from '../../Master/database/database.service';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { CostCenter } from '../../Master/costcenter/costcenter';
import { CostcenterService } from '../../Master/costcenter/costcenter.service';
import { ProductgroupService } from '../../Master/productgroup/productgroup.service';
import { ProductGroup } from '../../Master/productgroup/productgroup';
import { TypeService } from '../../Master/type/type.service';
import { Type } from '../../Master/type/type';
import { DatePipe } from '@angular/common';
import { BsDatepickerConfig, BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap';
import { UseraddService } from '../../Master/useradd/useradd.service';
import { FormrenderService } from '../../formrender/formrender.service';
import { FormdashboardService } from '../../dashboard/formdashboard/formdashboard.service';
import { requeststatus } from '../../dashboard/requestdashboard/requeststatus';
import { RequestdashboardService } from '../../dashboard/requestdashboard/requestdashboard.service';
import { saveFile, saveAs } from 'file-saver';
import { location } from 'ngx-bootstrap/utils/facade/browser';
import { ProductdetailsComponent } from './productdetails/productdetails.component';
import { NgxSpinnerService } from "ngx-spinner";
import { UserService } from '../../Master/user/user.service';
import * as XLSX from 'xlsx';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import { LocalService } from '../../local.service';
import {encryptdecrypt} from '../../encryptdecrypt';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[productdatacontainer]',
})
export class productDatacontainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}


@Component({
  selector: 'app-requestconfig',
  templateUrl: './requestconfig.component.html',
  styleUrls: ['./requestconfig.component.css']
})
export class RequestconfigComponent implements OnInit, AfterViewInit {

  filedetailsformconversion: ConversionrequestFileDetail;
  sendMenuId: number = 28;
  sendPageName: string = 'Request';
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean; _menuId: any;
  businessUnits: Businessunit[]; today = new Date(); products: Product[] = [];
  _dropdownSettings: any
  requestType = false; requestinfoshow = false; downloadInstrshow = false; documentInfo = false;
  otherCites = false; queryDetails = false
  details = false; conversionInfo = false; filename = false;
  costlimitations = false;
  selectall = false;
  requestConfigForm: FormGroup; conversiondetailsForm: FormGroup; requestConfig: RequestconfigModel;
  databases: any = []; dbid: number = 0; 
  //public username = localStorage.getItem('username');
  public username = this.localService.getJsonValue('username');
  costCenters: CostCenter[]; ProductGroups: ProductGroup[]
  types: Type[]
  dirPaths: string[] = []; selectprod: Product; deselectProd: Product;
  queryObj: any; requestDetails: any;
  operationType = 'add';
  requestdetailid: number; requesttypeid: number;
  bsInlineValue = new Date();
  desiredCompDate: any;
  //query param
  documentId: number = 0;
  formConfigId: number = 0;
  requestTypeId: number = 0;
  courtagostatusid: number = 0;
  formName: string = '';
  descisionDatetextvalue: Date;
  requestinfoContent = true; downloadInstrContent = true; documentInfoContent = true;
  otherCitesContent = true; detailsContent = true;
  conversionInfoContent = true; queryDetailsContent = true
  requestinfo = false;
  domesticInfo = false;
  otherCite = false;
  costcenter = false;
  subject = false;
  reqreport = false;
  reqparagraph = false;
  reqprodformat = false;
  reqcostcenter = false;
  reqprodgroup = false;
  reqprodname = false;
  items: any; _usermappedDatabase = [];
  userid: number;
  check: boolean = false;
  selectedProducts: Product[] = [];
  editProductsname: Product = new Product();
  productname: string = '';
  attachedFileList: any = [];
  requeststatus: requeststatus = new requeststatus();
  conversionuser: boolean = false;
  outputFormatbinding: boolean = false;
  viewrequest: boolean = false;
  documentinfodesiredCompDateValue: any; docInfoDescisionopinionDateValue: any;
  detailsdesiredcompletiondatevalue: any; querydetailsdesiredcompletiondatevalue: any
  conversionDocUpload: boolean = false;
  attachfilepath: string = '';
  attachfileName: string = '';
  attachconversionfileName: string = '';
  finaluploadfilenameedit: string = '';
  finaluploadfilename: string = '';
  attachconversionfilepath: string = '';
  public dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  selectedproduct: string = '';
  @ViewChildren(productDatacontainerDirective) entry: QueryList<productDatacontainerDirective>;
  product: ConversionrequestDetail[] = [];
  proceedconversion: boolean = false;
  prodformar: any;
  courtagores: any;
  requestDetailsago: any;
  courtagofinaluploadfilename: string = '';
  childcreatedproduct: { productid: number, index: number }[] = [];
  counter = 0;
  defaultbindingdbid: number = 0;
  allproducts: Product[] = [];
  //back to request dashboard
  selectedDataBase: any;
  userType: any;
  selectedColumnShow: any;
  selectedReqType: any;
  selectedPageNumber: any;
  selectedItemsPerPage: any;
  selectedSearchCondition: any;
  selectedSortCondition: any;
  selectedSearchConditionList: any;
  disable = false;
  isprimary: boolean = false;  
  productDisable = false;
  conversionFileList: any = []; supportingFileList: any = []; showconversionfiles: boolean = false
  focusinto = false;
  usersList = [];

  listofurlfromtemplate = [];
  templateuploadedname = '';

  internetdownloadstatusid: number = 0;
  internetdownloadproceedconversion: boolean = false;

  uploadedFilesList: any[] = [];
  isnoupdatemailsend = false;

  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    ignoreBackdropClick: true,
    class: 'modal-dialog-centered'

  }

  filesUploadModal: BsModalRef;

  mylist: any[] = []; mytemplist: any[] = [];
  mappedfilesList: any[] = []; mappingcomplete: any;
  showMappedList: boolean = false

  showuploadFile = true;
  relatedDocuments = [];
  mainProductList = [];
  mainBusinessUnitList = [];

  fromForm = false;

  supportuser: boolean = false;
  redirectmodeforproduct: any;

  existIds = [];
  popupModalRef: BsModalRef;
  postData: any;
  fileuploadedproduct = 0;
  executableFileTypes=[];
  enc=new encryptdecrypt();
apiCreatedRequest=0;
  @ViewChild('checkExistConversion', { static: false }) private checkExistConversion: TemplateRef<any>;


  //Constructor
  constructor(private businessUnitService: BusinessunitService, private toastr: ToastrService,
    private productsService: ProductService, private router: Router,
    private _frmBuilder: FormBuilder, private requestConfigService: RequestconfigService,
    private route: ActivatedRoute, private databaseService: DatabaseService, private dialogService: DialogService,
    private typeService: TypeService, private productGroupService: ProductgroupService,
    private costcenterservice: CostcenterService, private datePipe: DatePipe,
    private useraddService: UseraddService,
    private formRenderService: FormrenderService,
    private formdashboardservice: FormdashboardService,
    private requestdashboardservice: RequestdashboardService, private resolver: ComponentFactoryResolver,
    private SpinnerService: NgxSpinnerService, private userservice: UserService, 
    private modalService: BsModalService, private contextMenuService: ContextMenuService,
    private localService: LocalService
  ) {

    ////code to get relavent menu id
    //if (this.router.getCurrentNavigation().extras.state != undefined) {
    //  localStorage.setItem('Team Management_menuid', this.router.getCurrentNavigation().extras.state.menuid);
    //  localStorage.setItem('Team Management_action', this.router.getCurrentNavigation().extras.state.action);
    //  this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
    //  this.sendMenuId = this._menuId;
    //  this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    //}
    //else {
    //  if (this._menuId == undefined)
    //    this._menuId = localStorage.getItem('Team Management_menuid');
    //  this.sendMenuId = this._menuId;
    //  if (this._actionRights == undefined)
    //    this._actionRights = localStorage.getItem('Team Management_action');
    //}
    const navigation = this.router.getCurrentNavigation();
    const state = navigation.extras.state as {
      selectedDataBase: any;
      userType: any;
      selectedColumnShow: any;
      selectedReqType: any;
      selectedPageNumber: any;
      selectedItemsPerPage: any;
      selectedSearchCondition: any;
      selectedSortCondition: any;
      selectedSearchConditionList: any;
    };
    if (state != null && state != undefined) {
      this.selectedDataBase = state.selectedDataBase;
      this.userType = state.userType;
      this.selectedColumnShow = state.selectedColumnShow;
      this.selectedReqType = state.selectedReqType;
      this.selectedPageNumber = state.selectedPageNumber;
      this.selectedItemsPerPage = state.selectedItemsPerPage;
      this.selectedSearchCondition = state.selectedSearchCondition;
      this.selectedSortCondition = state.selectedSortCondition;
      this.selectedSearchConditionList = state.selectedSearchConditionList
    }
    this.executableFileTypes=[{ 'type': 'exe'}, { 'type': 'sh'},{ 'type': 'js'},{ 'type': 'dll'},
    { 'type': 'bat'},{ 'type': 'bin'},{ 'type': 'job'},{ 'type': 'msi'},{ 'type': 'reg'},{ 'type': 'vb'}];
  }

  //code to get action rights
  getActionRightsList() {
   let a= new encryptdecrypt();
    this.userservice.Get().subscribe(res => {
res.forEach((data: any) => {
        data.firstname = a.decryptUsingAES256(data.firstname);
        data.lastname = a.decryptUsingAES256(data.lastname);
        data.emailid = a.decryptUsingAES256(data.emailid);
      });
      let allUser: any = [];
      this.usersList = res;
      
      allUser = res.find(y => y.userid == this.userid);
      var data = JSON.parse(allUser.menumapped);
      if (data != null && data != undefined && data.length != 0) {
        data = data.filter(e => e.menuid == this.sendMenuId);
        if (data != null && data != undefined && data.length != 0)
          this._actionRights = data[0].action;
        else
          this._actionRights = [];

      }
      
      var btnToEnable = this._actionRights;
      if (btnToEnable.length > 0) {
        btnToEnable.forEach(d => {
          if (d != undefined) {
            if (d == 1)
              this.readOnly = true;
            else if (d == 2) {
              this.readOnly = true;
              this.add = true;
              this.submitShow = true;
            }
            else if (d == 3) {
              this.readOnly = true;
              this.edit = true;
              // this.submitShow = true;
            }
            else if (d == 4) {
              this.readOnly = true;
              this.delete = true;
            }
          }
        });
      }
    })
  }

  //Event after init
  ngAfterViewInit() {

    //if (this.queryObj.params.requestid != undefined) {

    //  this.getRequestDatabasedonId();
    //}

    this.route.queryParamMap.subscribe(params => {
      this.queryObj = params;
      //console.log(this.queryObj.params.documentId, this.queryObj.params.formConfigId);
      // this.requestdetailid = this.queryObj.params.requestid; this.requesttypeid = this.queryObj.params.requesttypeid;
    });
    if ((this.documentId != undefined) && (this.formConfigId != undefined)) {
      this.requestTypeId = this.requesttypeid;
      // this.getRequestDatabasedonId();
      if (this.requestTypeId != 0) {
        if (this.requestTypeId == 1) {
          var event = { currentTarget: { id: 'courtOpenionReqChk', checked: true } };
          this.requestConfigForm.controls['courtagoopinionrequeststatus'].setValue(true);
          $("#courtOpenionReqChk").prop('checked', 'true');
          this.selectRequestType(event)
        }
        if (this.requestTypeId == 2) {
          var event = { currentTarget: { id: 'researchGroupReqChk', checked: true } };
          this.requestConfigForm.controls['researchgrouprequeststatus'].setValue(true);
          $("#researchGroupReqChk").prop('checked', 'true');
          this.selectRequestType(event)
        }
        if (this.requestTypeId == 3) {
          var event = { currentTarget: { id: 'informationReqChk', checked: true } };
          this.requestConfigForm.controls['informationrequeststatus'].setValue(true);
          $("#informationReqChk").prop('checked', 'true');
          this.selectRequestType(event)
        }
        if (this.requestTypeId == 4) {
          var event = { currentTarget: { id: 'internetDownloadReqChk', checked: true } };
          this.requestConfigForm.controls['internetdownloadrequeststatus'].setValue(true);
          $("#internetDownloadReqChk").prop('checked', 'true');
          this.selectRequestType(event)
        }
        if (this.requestTypeId == 5) {
          var event = { currentTarget: { id: 'conversionReqChk', checked: true } };
          this.requestConfigForm.controls['conversionrequeststatus'].setValue(true);
          $("#conversionReqChk").prop('checked', 'true');
          this.selectRequestType(event)
        }
        //this.requestConfigForm.controls['dbid'].setValue(this.dbid);
        // this.loadFileDetails();
        // if (this.finaluploadfilenameedit == '')
       // this.loadFileDetails();


      }
    }


  }
  async getCurrentDate() {
    return await this.requestConfigService.GetServerDate().toPromise().then(res => res.date);
  }
  //Event onint
  async ngOnInit() {
    this.SpinnerService.show();
    
    this._dropdownSettings = {
      singleSelection: false,
      idField: 'productid',
      textField: 'product',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      //itemsShowLimit:2,
      allowSearchFilter: true
    };
    //  this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');
   
    this.route.queryParamMap.subscribe(params => {   
     
      this.queryObj = params;
      if(this.queryObj.params.requestid !=undefined && this.queryObj.params.requestid!='')
      this.requestdetailid =this.enc.decryptUsingAES256(this.queryObj.params.requestid.toString()); //this.queryObj.params.requestid; 
      if(this.queryObj.params.requesttypeid !=undefined && this.queryObj.params.requesttypeid!='')
      this.requesttypeid = this.enc.decryptUsingAES256(this.queryObj.params.requesttypeid.toString());//this.queryObj.params.requesttypeid;    
      if(this.queryObj.params.db !=undefined && this.queryObj.params.db!='')
      this.dbid = +this.enc.decryptUsingAES256(this.queryObj.params.db.toString());//+this.queryObj.params.db;
      else
      this.dbid =NaN;
      if(this.queryObj.params.documentId !=undefined && this.queryObj.params.documentId!='')
      this.documentId = this.enc.decryptUsingAES256(this.queryObj.params.documentId.toString());//this.queryObj.params.documentId; 
      if(this.queryObj.params.formConfigId !=undefined && this.queryObj.params.formConfigId!='')
      this.formConfigId =  this.enc.decryptUsingAES256(this.queryObj.params.formConfigId.toString());//this.queryObj.params.formConfigId;
      if(this.queryObj.params.formName !=undefined && this.queryObj.params.formName!='')
      this.formName = this.enc.decryptUsingAES256(this.queryObj.params.formName.toString());// this.queryObj.params.formName;
      this.fromForm = this.formName != null && this.formName != undefined && this.formName != '' ? true : false;
      if(this.queryObj.params.redirectmode !=undefined && this.queryObj.params.redirectmode!='')
      this.redirectmodeforproduct = this.enc.decryptUsingAES256(this.queryObj.params.redirectmode.toString());//this.queryObj.params.redirectmode;
     else
     this.redirectmodeforproduct='';
     
     
      if (this.redirectmodeforproduct == 'conversionuser') {
        this.conversionuser = true;
        this.viewrequest = true;
        setTimeout(function () {
          $('#requestConfigparentdiv input').keydown(function (event) {
			 var ctrlDown = event.ctrlKey || event.metaKey;
            var copypaste = (event.keyCode == 67 && ctrlDown) || (event.keyCode == 65 && ctrlDown);
            if (!copypaste) {
              event.preventDefault();
            }											  
           // event.preventDefault();
          });
        }, 6000);
      }
      else
        this.conversionuser = false;

      if (this.redirectmodeforproduct == 'supportuser') {
        this.supportuser = true;
      }
      else
        this.supportuser = false;


      if (this.redirectmodeforproduct == 'viewrequest') {
        setTimeout(function () {
          $('#requestConfigparentdiv input').keydown(function (event) {
			var ctrlDown = event.ctrlKey || event.metaKey;
            var copypaste = (event.keyCode == 67 && ctrlDown) || (event.keyCode == 65 && ctrlDown);
            if (!copypaste) {
              event.preventDefault();
            }															  
          //  event.preventDefault();
          });
        }, 6000);
        this.viewrequest = true;
      }
    });

    if (this.queryObj.params.requestid != undefined) {
      this.operationType = 'update';
    }

    this.InitializeControls();
    this.getActiveBusinessUnits();
    // this.getActiveProducts();
    await this.getAllProducts();
    await this.getDatabases();
    if (this.requestTypeId != 0) {
      this.loadFileDetails();
    }
    this.getCostCenters();
    this.getProductGroup();
    this.getTypeDetails();




   

    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();

    if (this.queryObj.params.requestid != undefined) {
      this.operationType = 'update';
      //this.getRequestDatabasedonId();
    }

    this.dpConfig = {
      isAnimated: true, adaptivePosition: true, containerClass: 'theme-dark-blue', dateInputFormat: 'MM/DD/YYYY'
    }
    //$('body').addClass('nav-sm').removeClass('nav-md');
    if (this.requesttypeid == 5) {
      this.conversionInfo = true;
    }


    const currentDate = await this.getCurrentDate();
    this.bsInlineValue = new Date(currentDate);
    this.today = new Date(currentDate);

    if (this.queryObj.params.requestid != undefined) {
      this.SpinnerService.show();

      this.getRequestDatabasedonId();
    }

  }

  //Code to initialize controls
  InitializeControls() {
    this.requestConfigForm = this._frmBuilder.group({
      dbid: [0, Validators.required],
      courtagoopinionrequeststatus: [false],
      researchgrouprequeststatus: [false],
      informationrequeststatus: [false],
      internetdownloadrequeststatus: [false],
      conversionrequeststatus: [false],
      businessunit: [0, Validators.required],
      product: ['', [Validators.required]],
      report: ['', [Validators.required]],
      paragraph: ['', [Validators.required]],
      productformat: ['', Validators.required],
      printonly: ['', Validators.required],
      electroniconly: ['', Validators.required],
      printandelectronic: ['', Validators.required],
      dctm: ['', Validators.required],
        alfresco: ['', Validators.required],

      documentinfo__desiredcompletiondate: [Validators.required],
      documentinfo_samedayturnaround: [false, Validators.required],
      courtagoopinion: [Validators.required],
      courtopinion: [false, Validators.required],
      ago: [false, Validators.required],
      //Opiniontype: ['', Validators.required],
      docketoragonumber: ['', Validators.required],
      descisionopiniondate: [Validators.required],
      courtoragoissuingstate: ['', Validators.required],
      casenameoragosubject: ['', Validators.required],
      judgesname: ['', Validators.required],
      westcite: ['', Validators.required],
      westlawcite: ['', Validators.required],
      lexiscite: ['', Validators.required],
      taxanalysiscite: ['', Validators.required],
      url: ['', Validators.required],
      othersources: ['', Validators.required],
      documentinfo_editorscomments: ['', Validators.required],
      conversionFile: [''],
      productgroup: [0],
      costcenter: [0],
      filename: ['', Validators.required],
      detaileddescriptionofrequest: ['', Validators.required],
      attachfile: ['', Validators.required],
      shortdescriptionforyourreference: ['', Validators.required],
      detailsdesiredcompletiondate: [Validators.required],
      detailssamedayturnaround: ['', Validators.required],
      searchtermkeywords: ['', Validators.required],
      desirednumberofhits: ['', Validators.required],
      costlimitations: ['', Validators.required],

      querydetailsdesiredcompletiondate: [Validators.required],
      querydetailssamedayturnaround: [false, Validators.required],
      request: ['', Validators.required],
      querydetailseditorscomments: ['', Validators.required],
      subject: ['', Validators.required],
      conversionreqdocid: [''],
      conversionreqattachfile: [''],
      dtlsFileUpld: [''],
      urlofdesireddocument: ['', Validators.required],
      downloadinformationeditorscomments: ['', Validators.required],
      detaileddescriptionforuseifurlisinvalid: ['', Validators.required],              
      PrintandElectronic: [''],
      PrintOnly: [''],
      ElectronicOnly: [''],
      DCTM: [''],
      Alfresco:[''],
      containsgraphics: [''], detailnumberofhours: [0],
      querydetailsnumberofhours: [0],
      documentinfonumberofhours: [0],
      alsonotify: [''],    
      listofurlfromtemplate: [],
      attachtemplatefile: [''],
      templateuploadedname: [''],
      samefileforall: false,
      userdocumentid: ['']

      // productdetails: this._frmBuilder.array([])
    })
    //this.conversiondetailsForm = this._frmBuilder.group({
    //  conversionrequestid: [],
    //  conversionrequestdetailid: [],
    //  productdesiredcompletiondate: [Validators.required],
    //  desiredfilename: ['', Validators.required],
    //  //finaldirectory: ['', Validators.required],
    //  type: [0, Validators.required],
    //  outputfiles: ['', Validators.required],
    //  dtdname: [0, Validators.required],
    //  xmlcontentarea: ['', Validators.required],
    //  productsamedayturnaround: [false, Validators.required],

    //  specifyothers: ['', Validators.required],
    //})
  }

  //code to bind data on edit
  getRequestDatabasedonId() {

    this.SpinnerService.show();
     
   let requestid= this.enc.decryptUsingAES256(this.queryObj.params.requestid.toString());
   let requesttypeid= this.enc.decryptUsingAES256(this.queryObj.params.requesttypeid.toString());
    this.requestConfigService.GetById(+requestid, +requesttypeid).toPromise().then(res => {

      this.requestDetails = res;
    console.log(this.requestDetails);

      if (this.requestDetails != null)
           this.requestDetails = JSON.parse(this.requestDetails[0].j);

      

      //disable all request checkboxes
      $("#courtOpenionReqChk").prop('disabled', 'true');
      $("#researchGroupReqChk").prop('disabled', 'true');
      $("#informationReqChk").prop('disabled', 'true');
      $("#internetDownloadReqChk").prop('disabled', 'true');
      $("#conversionReqChk").prop('disabled', 'true');


      if (this.requestDetails) {
        console.log(this.requestDetails[0].apirequest);
        this.apiCreatedRequest=+this.requestDetails[0].apirequest;
        let relatedDocuments = this.requestDetails[0].relateddocuments != null && this.requestDetails[0].relateddocuments != undefined ? this.requestDetails[0].relateddocuments : [];
        this.relatedDocuments = this.getRelatedDocumentsList(relatedDocuments);
        this.username = this.requestDetails[0].firstname;
        this.today = this.requestDetails[0].createdon;
        this.dbid = +this.requestDetails[0].dbid;
        this.requestConfigForm.controls['dbid'].setValue(this.requestDetails[0].dbid);
        //  $("#dbid").prop('disabled', 'true');
        this.disable = true;
        if (this.requestDetails[0].productname)
          this.selectedProducts = this.getcustomlist(this.requestDetails[0].productname, 'product');
        this.documentId = this.requestDetails[0].documentid
        if (this.requestDetails[0].documentmode != 'direct') {
          this.formName = this.requestDetails[0].documentmode
          this.fromForm = this.formName != null && this.formName != undefined && this.formName != '' ? true : false;
          this.loadFileDetails();
        }

        if (this.requestDetails[0].containsgraphics === 1) {
          this.requestConfigForm.controls['containsgraphics'].setValue(true);
        }
        else {
            this.requestConfigForm.controls['containsgraphics'].setValue(false);
        }


        this.requestConfigForm.controls['alsonotify'].setValue(this.getemailstring(this.requestDetails[0].alsonotify));
        this.requestConfigForm.controls['userdocumentid'].setValue(this.requestDetails[0].userdocumentid);	
        if (this.requestDetails[0].requesttype == 'courtagoopinionrequest') {
          //$('#courtOpenionReqChk').prop('checked', true)
          this.productDisable = this.requestDetails[0].proceedconversion == 1;
          this.courtagostatusid = this.requestDetails[0].statusid;
          this.requestConfigForm.controls['courtagoopinionrequeststatus'].setValue(true);
          var event = { currentTarget: { id: 'courtOpenionReqChk', checked: true } };
          //console.log(event.currentTarget.id)
          this.selectRequestType(event)
          //this.selectRequestType(event);
          this.requestConfigForm.controls['businessunit'].setValue(this.requestDetails[0].businessunit);


          //this.selectedProducts = this.requestDetails[0].productname
          //this.selectedProducts = this.getcustomlist(this.requestDetails[0].productname, 'product');
          //this.requestConfigForm.controls['product'].setValue(this.selectedProducts);
          if (this.allproducts.length > 0) {
            this.products = this.allproducts;
            this.selectedProducts = this.requestDetails[0].productname;
            this.selectedProducts = this.getcustomlist(this.requestDetails[0].productname, 'product');
            this.requestConfigForm.controls['product'].setValue(this.selectedProducts);
          }
          else {
            this.productsService.Get().subscribe(res => {
              let productsTmpList = [];
              productsTmpList = res;
              this.products = [];
              this.products = productsTmpList;
              this.selectedProducts.push(productsTmpList.find(x => x.productid == this.requestDetails[0].productid));
              this.selectedProducts = this.getcustomlist(this.selectedProducts, 'product');
              this.requestConfigForm.controls['product'].setValue(this.selectedProducts);
              this.editproductcomponentcalling();
            }, error => {
              this.toastr.error('Unable to get product data');
            });
          }
          this.requestConfigForm.controls['report'].setValue(this.requestDetails[0].report);
          this.requestConfigForm.controls['paragraph'].setValue(this.requestDetails[0].paragraph);
          this.finaluploadfilenameedit = this.requestDetails[0].finalupload;
          this.prodformar = this.requestDetails[0].productformat

          if (this.requestDetails[0].samedayturnaround === 1)
            this.requestConfigForm.controls['documentinfo_samedayturnaround'].setValue(true);
          else {
            this.requestConfigForm.controls['documentinfo_samedayturnaround'].setValue(false);
          }

          this.courtagores = this.requestDetails[0].courtoragoopinion;


          //this.prodformar.forEach((d) => {
          //  if (d.name == 'PrintOnly')
          //    this.requestConfigForm.controls["PrintOnly"].setValue(d.value);
          //  if (d.name == 'ElectronicOnly')
          //    this.requestConfigForm.controls["ElectronicOnly"].setValue(d.value);
          //  if (d.name == 'PrintandElectronic')
          //    this.requestConfigForm.controls["PrintandElectronic"].setValue(d.value);
          //});
          this.prodformar.forEach((d) => {
            if (d.name == 'PrintOnly' && d.value == 1)
              this.requestConfigForm.controls["printonly"].setValue(true);
            if (d.name == 'ElectronicOnly' && d.value == 1)
              this.requestConfigForm.controls["electroniconly"].setValue(true);
            if (d.name == 'PrintandElectronic' && d.value == 1)
              this.requestConfigForm.controls["printandelectronic"].setValue(true);
            if (d.name == 'DCTM' && d.value == 1)
              this.requestConfigForm.controls["dctm"].setValue(true);
            if (d.name == 'Alfresco' && d.value == 1)
              this.requestConfigForm.controls["alfresco"].setValue(true);
          });

          //console.log(this.datePipe.transform(this.requestDetails[0].desiredcompletiondate, "MM/dd/yyyy"));
          //this.requestConfigForm.controls['documentinfo__desiredcompletiondate'].setValue(this.requestDetails[0].desiredcompletiondate);
          this.docInfoDescisionopinionDateValue = this.datePipe.transform(this.requestDetails[0].descisionopinion, "MM/dd/yyyy");
          this.documentinfodesiredCompDateValue = this.datePipe.transform(this.requestDetails[0].desiredcompletiondate, "MM/dd/yyyy");
          this.requestConfigForm.controls['docketoragonumber'].setValue(this.requestDetails[0].docketagonumber);
          this.requestConfigForm.controls['descisionopiniondate'].setValue(this.requestDetails[0].descisionopinion);
          this.requestConfigForm.controls['courtoragoissuingstate'].setValue(this.requestDetails[0].courtagoissuingstate);

          this.requestConfigForm.controls['casenameoragosubject'].setValue(this.requestDetails[0].casenameagosubject);
          this.requestConfigForm.controls['judgesname'].setValue(this.requestDetails[0].judgesname);
          this.requestConfigForm.controls['westcite'].setValue(this.requestDetails[0].westcite);
          this.requestConfigForm.controls['westlawcite'].setValue(this.requestDetails[0].westlawcite);
          this.requestConfigForm.controls['lexiscite'].setValue(this.requestDetails[0].lexiscite);
          this.requestConfigForm.controls['taxanalysiscite'].setValue(this.requestDetails[0].taxanalystscite);
          this.requestConfigForm.controls['url'].setValue(this.requestDetails[0].url);
          this.requestConfigForm.controls['othersources'].setValue(this.requestDetails[0].othersource);
          this.requestConfigForm.controls['documentinfo_editorscomments'].setValue(this.requestDetails[0].editorscommnets);
          this.requestConfigForm.controls['documentinfonumberofhours'].setValue(this.requestDetails[0].documentinfonumberofhours); 
        }

        //Code to bind research group request details
        if (this.requestDetails[0].requesttype == 'researchgrouprequest') {

          this.requestConfigForm.controls['researchgrouprequeststatus'].setValue(true);
          var event = { currentTarget: { id: 'researchGroupReqChk', checked: true } };
          this.selectRequestType(event);
          this.requestConfigForm.controls['businessunit'].setValue(this.requestDetails[0].businessunit);
          this.requestConfigForm.controls['costcenter'].setValue(this.requestDetails[0].costcenter);
          this.requestConfigForm.controls['productgroup'].setValue(this.requestDetails[0].productgroup);
          this.requestConfigForm.controls['detaileddescriptionofrequest'].setValue(this.requestDetails[0].detaileddescriptionofrequest);
          this.requestConfigForm.controls['desirednumberofhits'].setValue(this.requestDetails[0].desirednumberofhits);
          this.requestConfigForm.controls['searchtermkeywords'].setValue(this.requestDetails[0].searchtermkeywords);
          this.requestConfigForm.controls['detailnumberofhours'].setValue(this.requestDetails[0].detailnumberofhours); 
          this.finaluploadfilenameedit = this.requestDetails[0].finalupload;
          if (this.requestDetails[0].samedayturnaround === 1)
            this.requestConfigForm.controls['detailssamedayturnaround'].setValue(true);
          else {
            this.requestConfigForm.controls['detailssamedayturnaround'].setValue(false);
          }
          this.requestConfigForm.controls['costlimitations'].setValue(this.requestDetails[0].costlimitations);
          this.requestConfigForm.controls['shortdescriptionforyourreference'].setValue(this.requestDetails[0].shortdescriptionforyourreference);
          //this.requestConfigForm.controls['costlimitations'].setValue(this.requestDetails[0].costlimitations);
          if (this.requestDetails[0].desiredcompletiondate != null)
            this.detailsdesiredcompletiondatevalue = this.datePipe.transform(this.requestDetails[0].desiredcompletiondate, "MM/dd/yyyy")
          //this.requestConfigForm.controls['desiredcompletiondate'].setValue(this.requestDetails[0].desiredcompletiondate);
          this.attachfilepath = this.requestDetails[0].attachfile;

        }

        //Code to bind Information request details
        if (this.requestDetails[0].requesttype == 'informationrequest') {

          this.requestConfigForm.controls['informationrequeststatus'].setValue(true);
          var event = { currentTarget: { id: 'informationReqChk', checked: true } };
          this.selectRequestType(event);
          this.requestConfigForm.controls['businessunit'].setValue(this.requestDetails[0].businessunit);
          this.requestConfigForm.controls['filename'].setValue(this.requestDetails[0].filename);
          this.requestConfigForm.controls['detaileddescriptionofrequest'].setValue(this.requestDetails[0].detaileddescriptionofrequest);
          this.requestConfigForm.controls['shortdescriptionforyourreference'].setValue(this.requestDetails[0].shortdescriptionforyourreference);
          // this.requestConfigForm.controls['desiredcompletiondate'].setValue(this.requestDetails[0].desiredcompletiondate);
          this.requestConfigForm.controls['attachfile'].setValue(this.requestDetails[0].attachfile);
          if (this.requestDetails[0].detailssamedayturnaround === 1)
            this.requestConfigForm.controls['detailssamedayturnaround'].setValue(true);
          else {
            this.requestConfigForm.controls['detailssamedayturnaround'].setValue(false);
          }
          if (this.requestDetails[0].querydetailssamedayturnaround === 1)
            this.requestConfigForm.controls['querydetailssamedayturnaround'].setValue(true);
          else {
            this.requestConfigForm.controls['querydetailssamedayturnaround'].setValue(false);
          }
          this.requestConfigForm.controls['searchtermkeywords'].setValue(this.requestDetails[0].searchtermkeywords);
          this.requestConfigForm.controls['desirednumberofhits'].setValue(this.requestDetails[0].desirednumberofhits);
          this.requestConfigForm.controls['costlimitations'].setValue(this.requestDetails[0].costlimitations);
          this.requestConfigForm.controls['request'].setValue(this.requestDetails[0].request);
          this.requestConfigForm.controls['querydetailseditorscomments'].setValue(this.requestDetails[0].editorscomments);
          this.requestConfigForm.controls['detailnumberofhours'].setValue(this.requestDetails[0].detailnumberofhours); 
          this.requestConfigForm.controls['querydetailsnumberofhours'].setValue(this.requestDetails[0].querydetailsnumberofhours);
          this.detailsdesiredcompletiondatevalue = this.datePipe.transform(this.requestDetails[0].detailsdesiredcompletiondate, "MM/dd/yyyy");
          this.querydetailsdesiredcompletiondatevalue = this.datePipe.transform(this.requestDetails[0].querydetailsdesiredcompletiondate, "MM/dd/yyyy");
          this.requestConfigForm.controls['subject'].setValue(this.requestDetails[0].subject);
          this.attachfilepath = this.requestDetails[0].attachfile;
          this.finaluploadfilenameedit = this.requestDetails[0].finalupload;

        }

        //Code to bind Internet download request details
        if (this.requestDetails[0].requesttype == 'internetdownloadrequest') {

          this.requestConfigForm.controls['internetdownloadrequeststatus'].setValue(true);
          var event = { currentTarget: { id: 'internetDownloadReqChk', checked: true } };
          this.selectRequestType(event);
          this.requestConfigForm.controls['businessunit'].setValue(this.requestDetails[0].businessunit);
          this.requestConfigForm.controls['urlofdesireddocument'].setValue(this.requestDetails[0].urlofdesireddocument);
          this.requestConfigForm.controls['detaileddescriptionforuseifurlisinvalid'].setValue(this.requestDetails[0].detaileddescriptionforuseifurlisinvalid);
          this.requestConfigForm.controls['downloadinformationeditorscomments'].setValue(this.requestDetails[0].downloadinformationeditorscomments);
         // this.requestConfigForm.controls['documenteditorscomments'].setValue(this.requestDetails[0].documenteditorscomments);
        //  this.requestConfigForm.controls['documentdetaildescription'].setValue(this.requestDetails[0].documentdetaildescription);
          this.listofurlfromtemplate = this.requestDetails[0].listofurlfromtemplate == null ? [] : this.requestDetails[0].listofurlfromtemplate;
          this.requestConfigForm.controls['listofurlfromtemplate'].setValue(this.listofurlfromtemplate);
          this.templateuploadedname = this.requestDetails[0].templateuploadedname;
          this.requestConfigForm.controls['templateuploadedname'].setValue(this.requestDetails[0].templateuploadedname);
          this.detailsdesiredcompletiondatevalue = this.datePipe.transform(this.requestDetails[0].desiredcompletiondate, "MM/dd/yyyy");
          this.finaluploadfilenameedit = this.requestDetails[0].finalupload;
          this.productDisable = this.requestDetails[0].internetdownloadproceedconversion == 1;
          this.internetdownloadstatusid = this.requestDetails[0].statusid;
        }

        //Code to bind conversion request details
        if (this.requestDetails[0].requesttype == 'conversionrequest') {

          this.mylist = this.requestDetails[0].conversionfiledetails;
          if (this.mylist != null && this.mylist != undefined) {
            if (this.mylist.length > 0) {
              this.mytemplist = JSON.parse(JSON.stringify(this.mylist));
              for (var i = 0; i < this.mylist.length; i++) {
                if (this.mylist[i].isprimary === 'true') {
                  this.mytemplist = [];
                  this.mytemplist.push(JSON.parse(JSON.stringify(this.mylist[i])));
                  this.isprimary = true;
                }

              }
            }
          }
          //edit product in conversion request given by anbarasan
          this._dropdownSettings['singleSelection'] = this.operationType === 'update' && this.requestDetails[0].requesttype == 'conversionrequest';

          this.requestConfigForm.controls['conversionrequeststatus'].setValue(true);
          var event = { currentTarget: { id: 'conversionReqChk', checked: true } };
          this.selectRequestType(event);
          this.requestConfigForm.controls['businessunit'].setValue(this.requestDetails[0].businessunit);

          //this.selectedProducts.push(this.products.find(x => x.productid == this.requestDetails[0].productid));
          //this.selectedProducts = this.getcustomlist(this.selectedProducts, 'product');


          //this.requestConfigForm.controls['product'].setValue(this.selectedProducts);



          this.requestConfigForm.controls['report'].setValue(this.requestDetails[0].report);
          this.requestConfigForm.controls['paragraph'].setValue(this.requestDetails[0].paragraph);



          this.attachconversionfilepath = this.requestDetails[0].uploadfile;
          //this.finaluploadfilenameedit = this.requestDetails[0].finalupload;
          this.finaluploadfilenameedit = '';

          if (this.requestDetails[0].conversionfiledetails != undefined || this.requestDetails[0].conversionfiledetails != null) {
            this.requestDetails[0].conversionfiledetails.forEach(element => {
              if (element.finalupload != null) {
                if (this.finaluploadfilenameedit == '') {
                  this.finaluploadfilenameedit = element.finalupload;
                } else {
                  this.finaluploadfilenameedit = this.finaluploadfilenameedit + ':' + element.finalupload;
                }
              }
            });
          }
          this.prodformar = this.requestDetails[0].productformat
          this.requestConfigForm.controls['conversionreqdocid'].setValue(this.requestDetails[0].conversionreqdocid);

          //this.prodformar.forEach((d) => {
          //  if (d.name == 'PrintOnly')
          //    this.requestConfigForm.controls["PrintOnly"].setValue(d.value);
          //  if (d.name == 'ElectronicOnly')
          //    this.requestConfigForm.controls["ElectronicOnly"].setValue(d.value);
          //  if (d.name == 'PrintandElectronic')
          //    this.requestConfigForm.controls["PrintandElectronic"].setValue(d.value);
          //});
          this.prodformar.forEach((d) => {
            if (d.name == 'PrintOnly' && d.value == 1)
              this.requestConfigForm.controls["printonly"].setValue(true);
            if (d.name == 'ElectronicOnly' && d.value == 1)
              this.requestConfigForm.controls["electroniconly"].setValue(true);
            if (d.name == 'PrintandElectronic' && d.value == 1)
              this.requestConfigForm.controls["printandelectronic"].setValue(true);
            if (d.name == 'DCTM' && d.value == 1)
              this.requestConfigForm.controls["dctm"].setValue(true);
            if (d.name == 'Alfresco' && d.value == 1)
              this.requestConfigForm.controls["alfresco"].setValue(true);
          });

          this.requestConfigService.GetById(+this.requestDetails[0].courtagoopinionrequestid, 1).toPromise().then(res1 => {
            this.requestDetailsago = res1;
            this.requestDetailsago = JSON.parse(this.requestDetailsago[0].j);
            this.courtagofinaluploadfilename = this.requestDetails[0].uploadfile;

          }, err => {
            this.toastr.error('Error to Get Request Details');
            this.SpinnerService.hide();
          });

          //this.editproductcomponentcalling();

          if (this.allproducts.length != 0) {
            this.products = this.allproducts;
            this.selectedProducts.push(this.allproducts.find(x => x.productid == this.requestDetails[0].productid));
            this.selectedProducts = this.getcustomlist(this.selectedProducts, 'product');
            this.requestConfigForm.controls['product'].setValue(this.selectedProducts);
            this.editproductcomponentcalling();
          }
          else {
            this.productsService.Get().subscribe(res => {
              let productsTmpList = [];
              productsTmpList = res;
              this.products = [];
              this.products = productsTmpList;
              this.selectedProducts.push(productsTmpList.find(x => x.productid == this.requestDetails[0].productid));
              this.selectedProducts = this.getcustomlist(this.selectedProducts, 'product');
              this.requestConfigForm.controls['product'].setValue(this.selectedProducts);
              this.editproductcomponentcalling();
            }, error => {
              this.toastr.error('Unable to get product data');
            });
          }


        }
      }
      if (this.viewrequest == true) {

        $('input').keypress(function (event) {
          event.preventDefault();
        });
      }
      this.SpinnerService.hide();
    },
      err => {
        this.toastr.error('Error to Get Request Details');
        this.SpinnerService.hide();
      })

   // this.SpinnerService.hide();
  }

  editproductcomponentcalling() {

    var editProductsname = this.products.find(item => item.productid === this.requestDetails[0].productid);
    var editproductname = editProductsname.product;
    var editdirpath = editProductsname.dirpath;


    const myFactory = this.resolver.resolveComponentFactory(ProductdetailsComponent);
    var id = this.requestDetails[0].productid;
    var i = 0
    this.entry.forEach(container => {
      //let containerid = this.entry.element.nativeElement.id;
      const myRef = this.entry.toArray()[i].viewContainerRef.createComponent(myFactory);
      this.entry.toArray()[i].viewContainerRef.element.nativeElement.id = this.requestDetails[0].productid;
      myRef.instance['productid'] = this.requestDetails[0].productid;
      myRef.instance['productname'] = editproductname;
      myRef.instance['directorypath'] = editdirpath;
      myRef.instance['operation'] = 'edit';
      myRef.instance['viewrequest'] = this.viewrequest;
      myRef.instance['productdetailsedit'] = this.requestDetails;
      myRef.instance['productmodel'] = editProductsname;
      myRef.instance['proceedconversion'] = this.proceedconversion;
      myRef.instance['internetdownloadproceedconversion'] = this.internetdownloadproceedconversion;
      myRef.instance['fromForm'] = this.fromForm;
      myRef.instance['formattachfile'] = this.attachedFileList;
      myRef.instance['redirectmodeforproduct'] = this.redirectmodeforproduct;
      myRef.instance['apiCreatedRequest'] = this.apiCreatedRequest;
      myRef.instance['dbid'] = this.dbid;this.dbid
      
      var s = this.databases.filter(e => e.databaseid == this.dbid)
      if (s.length > 0) {
        myRef.instance['dbname'] = s[0].database;
      }
      myRef.instance['requestid'] = this.requestdetailid;
      // i = i + 1;
    });
  }

  //form valid mail structure suit for  multi select list
  getcustomlist(idlist, type) {

    var tempList = [];
    if (type == 'product') {

      if ((idlist != null) && (idlist.length != 0)) {
        idlist.forEach((d) => {
          this.products.forEach((data, ind) => {
            if (data.productid == d.productid) {
              tempList.push({
                productid: data.productid, product: data.product
              });
            }
          });
        });
      }
    }

    return tempList;
  }

  //Code to add product
  addProduct(data: Product): void {
    this.selectprod = this.products.find(item => item.productid === data.productid) as Product;

    //(<FormArray>this.requestConfigForm.get('productdetails')).push(this.createProduct());
    //this.items = this.requestConfigForm.get('productdetails') as FormArray;
    //if (this.dirPaths.indexOf(this.selectprod.dirpath) === -1)
    //  this.dirPaths.push(this.selectprod.dirpath);

    //this.items.at(this.items.length - 1).controls['productid'].setValue(this.selectprod.productid);
    //this.items.at(this.items.length - 1).controls['product'].setValue(this.selectprod.product);

  }

  //Code to return records from masters
  //Costcenter master
  getCostCenters() {
    this.costcenterservice.Get().subscribe(res => {
      this.costCenters = res;
      this.costCenters = this.costCenters.filter(
        costcenter => costcenter.active === 1);
    }, error => { this.toastr.error('Error while getting data'); });

  }

  //Product group master
  getProductGroup() {

    this.productGroupService.Get().subscribe(res => {

      this.ProductGroups = res
      this.ProductGroups = this.ProductGroups.filter(
        item => item.active === 1);
    }, err => {
      this.toastr.error('unable to get product Group Data')
    })


  }

  //type details master
  getTypeDetails() {
    this.typeService.Get().subscribe(res => {
      this.types = res
      this.types = this.types.filter(
        item => item.active === 1);

    }, err => {
      this.toastr.error('error while getting Type Data')
    })
  }

  getActiveBusinessUnits() {
    this.businessUnitService.GetActives().subscribe(res => {
      this.mainBusinessUnitList = JSON.parse(JSON.stringify(res));
      this.businessUnits = res;
    }, error => {
      this.toastr.error('Unable to get business unit data');
    })
  }

  async  getDatabases() {
    this.SpinnerService.show();
    await  Promise.all([this.databaseService.getActive().toPromise(), this.useraddService.GetById(this.userid).toPromise()]).then(
      ([databaseres, userres]) => {
        var allData = databaseres;
        this.defaultbindingdbid = allData.find(e => e.database == 'Conversion Requests').databaseid;
        // this.useraddService.GetById(this.userid).subscribe(res1 => {
        let user: any = [];
        user = userres.find(y => y.userid == this.userid);
        this._usermappedDatabase = JSON.parse(user.databasemapped).databasemapped;
        if ((this._usermappedDatabase != undefined) && (this._usermappedDatabase != null) && (this._usermappedDatabase.length > 0)) {
          allData.forEach(data => {
            if (data.active != 0) {
              var s = this._usermappedDatabase.filter(e => e.databaseid == data.databaseid);
              if ((s != undefined) && (s.length != 0)) {
                this.databases.push({
                  databaseid: data.databaseid,
                  database: data.database,
                  iconclass: data.iconclass,
                  databasedescription: data.databasedescription,
                  databaseiconpath: data.databaseiconpath,
                  status: data.status,
                  createdby: data.createdby,
                  createdon: data.createdon,
                  modifiedby: data.modifiedby,
                  modifiedon: data.modifiedon,
                  active: data.active,
                  databaseicon: data.databaseicon
                });
              }
            }
            // console.log(this.databases);
            if ((this.dbid == 0) || (this.dbid == undefined) || isNaN(this.dbid)) {
              this.route.params.subscribe(params => {          
               
                this.dbid = +this.enc.decryptUsingAES256(params['db'].toString());// +params['db'];
              });
            }

            if (isNaN(this.dbid)) {
              this.requestConfigForm.controls['dbid'].setValue(this.defaultbindingdbid);
            }
            else {
              this.requestConfigForm.controls['dbid'].setValue(this.dbid);
            }
          });

          let conversionReq = this.databases.filter(e => e.database == 'Conversion Requests');
          let dbId = conversionReq.length > 0 ? conversionReq[0].databaseid : 0;
          this.defaultbindingdbid = dbId == undefined ? 0 : dbId;
          if (isNaN(this.dbid)) {
            this.requestConfigForm.controls['dbid'].setValue(this.defaultbindingdbid);
          }
          else {
            this.requestConfigForm.controls['dbid'].setValue(this.dbid);
          }
        }
        else {
          this.databases = [];
        }
        // });
        this.SpinnerService.hide();
      },
      err => {
        this.SpinnerService.hide();
        this.toastr.error('Not able to get Database Data')
      });

  }

  productclear() {
    this.products.forEach(product => {
      this.entry.forEach(container => {
        container.viewContainerRef.clear();
      });
    })
  }

  //Code to save (Add/Update) data
  postRequestConfig(model: RequestconfigModel): boolean {
    let data = JSON.parse(JSON.stringify(model));
    if (this.requestConfigForm.value.courtagoopinionrequeststatus === false && this.requestConfigForm.value.researchgrouprequeststatus === false && this.requestConfigForm.value.informationrequeststatus === false &&
      this.requestConfigForm.value.internetdownloadrequeststatus === false && this.requestConfigForm.value.conversionrequeststatus === false) {
      this.toastr.error('Please select atleast one request to Proceed')
      return;
    }
    if (this.requestConfigForm.value.dbid == '0') {
      this.toastr.error('Please select Database')
      return;
    }
    if (this.requestConfigForm.value.businessunit === 0) {
      this.toastr.error('Please select Business Unit')
      return;
    }

    var prdctformat = []
    if (this.requestConfigForm.value.conversionrequeststatus === true && this.selectedProducts.length <= 0) {
      this.toastr.error('Please select atleast one product Conversion Request');
      return;
    }
    if (this.requestConfigForm.value.courtagoopinionrequeststatus === true && !data.documentinfo__desiredcompletiondate) {
      this.toastr.error('Please select Desired Completion date in Document Information tab for Court Ago Opinion Request');
      return;
    }
    if (this.requestConfigForm.value.researchgrouprequeststatus === true && !data.detailsdesiredcompletiondate) {
      this.toastr.error('Please select Desired Completion date in Details tab for Research Group Request');
      return;
    }
    if (this.requestConfigForm.value.informationrequeststatus === true && !data.detailsdesiredcompletiondate) {
      this.toastr.error('Please select Desired Completion date in Details tab for Information Request');
      return;
    }
    if (this.requestConfigForm.value.informationrequeststatus === true && !data.querydetailsdesiredcompletiondate) {
      this.toastr.error('Please select Desired Completion date in Query Details tab for Information Request');
      return;
    }

    //if (data.documentinfo_samedayturnaround) {
    //  if (data.documentinfonumberofhours == null || data.documentinfonumberofhours <= 0) {
    //    this.toastr.error('Please enter the number of hours in Document Information Tab');
    //    return;
    //  }
    //}

    //if (data.detailssamedayturnaround) {
    //  if (data.detailnumberofhours == null || data.detailnumberofhours <= 0) {
    //    this.toastr.error('Please enter the number of hours in Details Tab');
    //    return;
    //  }
    //}

    //if (data.querydetailssamedayturnaround) {
    //  if (data.querydetailsnumberofhours == null || data.querydetailsnumberofhours <= 0) {
    //    this.toastr.error('Please enter the number of hours in Query Details Tab');
    //    return;
    //  }
    //}


    $.each($("div#productFormat input[type=checkbox]"), function (a, b) {
      var obj = {};
      obj['name'] = $(this).attr("name")
      obj['value'] = $(this).prop("checked") == true ? 1 : 0

      prdctformat.push(obj)

    });


    var a = $('div#courtagoOpenion input[name=courtagoopinion]:checked').val();
    if (a === 'CourtOpinion') {
      data.courtagoopinion = 1
    }
    else if ((a === 'AGO')) {
      data.courtagoopinion = 2
    }


    data.productformat = JSON.stringify(prdctformat);

    this.selectedProducts.forEach(function (v) { delete v.product });
    data.product = JSON.stringify(this.selectedProducts);


    if (data.documentinfo_samedayturnaround) {
      data.documentinfo_samedayturnaround = 1
    }
    else {
      data.documentinfo_samedayturnaround = 0
    }
    if (data.detailssamedayturnaround) {
      data.detailssamedayturnaround = 1
    }
    else {
      data.detailssamedayturnaround = 0
    }


    if (data.querydetailssamedayturnaround) {
      data.querydetailssamedayturnaround = 1
    }
    else {
      data.querydetailssamedayturnaround = 0
    }

   
    var outputformat = []

    this.uploadedFilesList = [];
    data.productdetails = [];
   // data.productfiledetails = [];
    var count = 0
    var noOfHoursCount = 0;
    this.selectedProducts.forEach(selproduct => {
     // count = 0;
      this.entry.forEach(container => {
        let containerid = container.viewContainerRef.element.nativeElement.id;
        //  if (containerid == selproduct.productid) {
        if (container.viewContainerRef !== undefined) {
          if (container.viewContainerRef['_embeddedViews'].length != 0) {
            for (let i = 0; i < container.viewContainerRef['_embeddedViews'].length; i++) {
              if (container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.productid == selproduct.productid) {
               // data.productdetails.push(container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.getproductdetails());
               // var prodDesiredCompDate = container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.getproductdetails().productdesiredcompletiondate;
                var prodDetails = container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.getproductdetails();              
                var prodDesiredCompDate = prodDetails.productdesiredcompletiondate;
                if (prodDetails.productsamedayturnaround) {
                  if (prodDetails.numberofhours == null || prodDetails.numberofhours == '' || prodDetails.numberofhours < 0) {
                    noOfHoursCount++;
                  }
                }
                if (!prodDesiredCompDate)
                  count++;
                else {
                  data.productdetails.push(container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.getproductdetails());
                 // data.productfiledetails = container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.getproductfiledetails();
                  if (!this.proceedconversion) {                    
                    //this.uploadedFilesList.push(container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.getproductfiles());
                    let files = container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.getproductfiles();
                    this.uploadedFilesList.push({
                      files: files,
                      productid: selproduct.productid
                    });

                  }

                  
                }
              }
            }
          }
          //   }

        }
      });
    });




    //if (data.productdetails.length > 0 && ((this.documentId == 0) || (this.documentId == undefined))) {
    //  for (var i = 0; i < this.uploadedFilesList.length; i++) {
    //    //if (this.uploadedFilesList[i].files.length > 0) {
    //      var conversionfileexist = this.uploadedFilesList[i].files.filter(d => d.filetype == 'forConversion');
    //      let activefiles = conversionfileexist.filter(x => x.active == 1);
    //      if (conversionfileexist.length == 0 || activefiles.length == 0) {
    //        if ( !this.proceedconversion) {
    //          this.toastr.warning('Please upload atleast one conversion file for a product')
    //          return false;
    //        }
    //      }
    //   // }
    //  }
    //}



    //if ((this.documentId != 0) && (this.documentId != undefined)) {

    //  if (data.productdetails.length > 0) {

    //    this.attachedFileList.forEach(formdetails => {
    //      this.filedetailsformconversion = new ConversionrequestFileDetail();
         

    //    });
       
    //  }

    //}



    if (count > 0) {
      this.toastr.error("Please select Desired Completion Date For selected products");
      return false;
    }
    //if (noOfHoursCount > 0) {
    //  this.toastr.error('Please enter the number of hours For selected products');
    //  return;
    //}

    //data.createdby = +localStorage.getItem("userid");
    data.createdby = +this.localService.getJsonValue("userid");
    if ((this.documentId != 0) && (this.documentId != undefined)) {
      data.documentid = this.documentId;
      data.documentmode = this.formName;
    } else {
      data.documentmode = 'direct';
    }
    data.proceedconversion = 0;
    data.containsgraphics = 0;
    //if (this.attachfileName != '')
    //  data.attachfile = this.attachfileName;
    //else
    //  data.attachfile = this.attachfilepath;

    //if (this.attachconversionfileName != '')
    //  data.conversionreqattachfile = this.attachconversionfileName;
    //else
    //  data.conversionreqattachfile = this.attachconversionfilepath;

    if (this.attachfileName != '')
      data.attachfile = this.attachfileName;//.replace(/\s/g, '_').replace(/[%<>/\:*?&";|]/g, '');
    else
      data.attachfile = this.attachfilepath;//.replace(/\s/g, '_').replace(/[%<>/\:*?&";|]/g, '');
    if (this.attachconversionfileName != '')
      data.conversionreqattachfile = this.attachconversionfileName;//.replace(/\s/g, '_').replace(/[%<>/\:*?&";|]/g, '');
    else
      data.conversionreqattachfile = this.attachconversionfilepath;//.replace(/\s/g, '_').replace(/[%<>/\:*?&";|]/g, '');

    if (data.courtagoopinionrequeststatus == true) {
      if ((data.documentinfo__desiredcompletiondate != null) && (data.documentinfo__desiredcompletiondate != undefined))
        data.documentinfo__desiredcompletiondate = this.datePipe.transform(data.documentinfo__desiredcompletiondate, "MM/dd/yyyy");
      if ((data.descisionopiniondate != null) && (data.descisionopiniondate != undefined))
        data.descisionopiniondate = this.datePipe.transform(data.descisionopiniondate, "MM/dd/yyyy");
    }
    if (data.researchgrouprequeststatus == true || data.informationrequeststatus == true) {
      if ((data.detailsdesiredcompletiondate != null) && (data.detailsdesiredcompletiondate != undefined))
        data.detailsdesiredcompletiondate = this.datePipe.transform(data.detailsdesiredcompletiondate, "MM/dd/yyyy");
    }
    if (data.informationrequeststatus == true) {
      if ((data.querydetailsdesiredcompletiondate != null) && (data.querydetailsdesiredcompletiondate != undefined))
        data.querydetailsdesiredcompletiondate = this.datePipe.transform(data.querydetailsdesiredcompletiondate, "MM/dd/yyyy");
    }

    let regxpat = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    let validmailid = false;
    let externalMailList = [];
    let invalidMailCount = 0;
    if (data.alsonotify) {
      if (data.alsonotify.trim() != null && data.alsonotify.trim() !== '') {
        let b = data.alsonotify.split(';');
        b.forEach(element => {
          if (!regxpat.test(element)) {
            // this.toastr.warning('Please enter valid  Also Notify Mail id instead of ' + element);
            // validmailid = false;
            invalidMailCount++;
          } else {
            externalMailList.push(element);
            // validmailid = true;
          }
        });
        // if (!validmailid) {
        //   return;
        // }
      }
    }
    if (invalidMailCount > 0) {
      this.toastr.warning('Please enter valid  Also Notify Mail id');
      return false;
    }
    data.alsonotify = JSON.stringify(externalMailList);

    if (this.proceedconversion == true) {
      if ($('#conversionReqChk').is(':checked')) {
      }
      else {
        this.toastr.error("Please enter conversion related details");
        return false;
      }
    }
    //data.listofurlfromtemplate = this.listofurlfromtemplate != null && this.listofurlfromtemplate.length > 0 ? JSON.stringify(this.listofurlfromtemplate) : '';
    data.listofurlfromtemplate = this.listofurlfromtemplate != null ? JSON.stringify(this.listofurlfromtemplate) : JSON.stringify([]);

    data.templateuploadedname = this.templateuploadedname != null ? this.templateuploadedname : '';
    data['isnoupdatemailsend'] = this.isnoupdatemailsend;
    if (((this.requestConfigForm.value.courtagoopinionrequeststatus === true && this.requestConfigForm.value.internetdownloadrequeststatus === false) || (this.requestConfigForm.value.internetdownloadrequeststatus === true && this.requestConfigForm.value.courtagoopinionrequeststatus === false)) &&
      (this.requestConfigForm.value.conversionrequeststatus === false) &&
      this.proceedconversion == false && this.internetdownloadproceedconversion == false && this.operationType == 'add') {
      let showpopup = this.dialogService.addDialog(CommondialogComponent,
        {
          title: 'Please Confirm',
          message: 'Do you want to proceed with coversion after acquisition ?',
          hclass: 'modelsuccess',
          oktext: 'Yes',
          canceltext: 'No',
          okshow: true,
          cancelshow: true

        }).subscribe((isConfirmed) => {
          if (isConfirmed) {
            if (this.requestConfigForm.value.courtagoopinionrequeststatus) {
              this.proceedconversion = true;
            }

            if (this.requestConfigForm.value.internetdownloadrequeststatus) {
              this.internetdownloadproceedconversion = true;
            }
            var e = document.getElementById("conversionReqChk");
            (<HTMLInputElement>e).checked = true;
            var event = { currentTarget: { id: 'conversionReqChk', checked: true } };
            this.requestConfigForm.controls['conversionrequeststatus'].setValue(true);
            $("#conversionReqChk").prop('checked', 'true');
            this.selectRequestType(event)

            //       this.selectedProducts = [];
            this.toastr.warning("Please enter details for conversion");
            return false;
          }
          else {
            this.proceedconversion = false;
            this.internetdownloadproceedconversion == false;
            if (this.requestConfigForm.value.conversionrequeststatus && this.operationType == 'add') {
              this.checkConversionExist(data);
            } else {
              this.save(data);
            }
          }
        });
    }
    else {

      data.proceedconversion = this.proceedconversion == true ? 1 : 0;
      data.internetdownloadproceedconversion = this.internetdownloadproceedconversion == true ? 1 : 0;	

      if (this.requestConfigForm.value.conversionrequeststatus && this.operationType == 'add') {
        this.checkConversionExist(data);
      } else {
        this.save(data);
      }

    }

    return true;

  }

  save(data) {

    //if (this.requestConfigForm.value.conversionrequeststatus == true && this.attachconversionfilepath == '' && this.attachconversionfileName == '' && this.attachedFileList.length == 0 && data.proceedconversion == 0) {
    //  this.toastr.error('Please upload the file to Proceed Conversion Request');
    //  return;
    //}

    
    if (this.operationType === 'add') {
      //data.productdetails
      this.SpinnerService.show();
      this.requestConfigService.Post(data).subscribe(res => {
        if (res.body.retval != 0) {
          this.SpinnerService.hide();
          this.toastr.success('Request Form added successfully')

          this.productclear();
          //this.requestConfigForm.reset();
          if (this.requestConfigForm.get('dtlsFileUpld').value != null || this.requestConfigForm.get('conversionreqattachfile').value != null || this.requestConfigForm.get('attachtemplatefile').value != null) {
            const formData = new FormData();



            if (this.requestConfigForm.get('dtlsFileUpld').value != null)
              formData.set('dtlsFileUpld', this.requestConfigForm.get('dtlsFileUpld').value);




            if (this.uploadedFilesList.length > 0) {
              this.uploadedFilesList.forEach((filesdet) => {
                filesdet.files.forEach((files, index) => {
                  formData.set('conversionreqattachfile' + index + '*' + files.filetype + "*" + filesdet.productid, files);
                });
              });
            }



            if (this.requestConfigForm.get('attachtemplatefile').value != null) {
              formData.set('attachtemplatefile', this.requestConfigForm.get('attachtemplatefile').value);
            }





            var s = this.databases.filter(e => e.databaseid == data.dbid)
            formData.append('dbname', s[0].database);
            formData.append('requestdetailid', res.body.retval.toString());
            formData.append('type', 'create');




            this.requestConfigService.PostFile(formData).subscribe(
              (res) => {
                if (res.body != 0) {

                }
              }, error => {
                this.toastr.error("Error while uploading File uploaded during creation");
              });

          }
          this.InitializeControls();
          this.selectedProducts = [];
          // (<FormArray>this.requestConfigForm.get('productdetails')).clear();
          this.requestConfigForm.controls['businessunit'].setValue(0);
          this.requestConfigForm.controls['dbid'].setValue(this.defaultbindingdbid);
          this.requestConfigForm.get('product').setValue([]);
          $.each($("div#requestConfigparentdiv input[type=checkbox]"), function (a, b) {
            $(this).prop("checked", false)

          })
          this.requestinfoshow = false; this.otherCites = false; this.documentInfo = false; this.queryDetails = false; this.details = false; this.conversionInfo = false;
          this.downloadInstrshow = false;
          this.conversionDocUpload = false;
          this.documentId = null;
          this.proceedconversion = false;         
          this.listofurlfromtemplate = [];
          this.router.navigate(['/home/requestdashboard']);
        }

      },
        err => {
          this.SpinnerService.hide();
          this.toastr.error('not able to post the request data')
        })
    }
    if (this.operationType === 'update') {
   
      if ($("#courtOpenionReqChk").prop('checked') == true) {
        data.courtagoopinionrequestid = +this.enc.decryptUsingAES256(this.queryObj.params.requestid.toString());//+this.queryObj.params.requestid
      }
      if ($("#researchGroupReqChk").prop('checked') == true) {
        data.researchgrouprequestid =  +this.enc.decryptUsingAES256(this.queryObj.params.requestid.toString());//+this.queryObj.params.requestid
      }
      if ($("#informationReqChk").prop('checked') == true) {
        data.informationrequestid =  +this.enc.decryptUsingAES256(this.queryObj.params.requestid.toString());//+this.queryObj.params.requestid
      }
      if ($("#internetDownloadReqChk").prop('checked') == true) {
        data.internetdownloadrequestid =  +this.enc.decryptUsingAES256(this.queryObj.params.requestid.toString());//+this.queryObj.params.requestid
      }
      if ($("#internetDownloadReqChk").prop('checked') == true) {
        data.internetdownloadrequestid =  +this.enc.decryptUsingAES256(this.queryObj.params.requestid.toString());//+this.queryObj.params.requestid
      }
      if ($("#conversionReqChk").prop('checked') == true) {
        data.conversionrequestid =  +this.enc.decryptUsingAES256(this.queryObj.params.requestid.toString());//+this.queryObj.params.requestid
      }
      this.SpinnerService.show();
      if (this.requestDetails[0] != undefined && this.requestDetails[0] != null) {
        data.proceedconversion = this.requestDetails[0].proceedconversion;
      }
      this.requestConfigService.Put(data).subscribe(res => {
        if (res.body != 0) {
          this.SpinnerService.hide();
          this.toastr.success('Request Form updated successfully')
          this.productclear();
          //this.requestConfigForm.reset();
          this.statusupdate(12);
          const formData = new FormData();
          // formData.set('dtlsFileUpld', this.requestConfigForm.get('dtlsFileUpld').value);
          //if (this.requestConfigForm.get('dtlsFileUpld').value != null)
          //  formData.set('dtlsFileUpld', this.requestConfigForm.get('dtlsFileUpld').value);
          //if (this.requestConfigForm.get('conversionreqattachfile').value != null)
          //  formData.set('conversionreqattachfile', this.requestConfigForm.get('conversionreqattachfile').value);
          //if (this.requestConfigForm.get('attachtemplatefile').value != null) {
          //  formData.set('attachtemplatefile', this.requestConfigForm.get('attachtemplatefile').value);
          //}
          var filename = '';
          if (this.requestConfigForm.get('dtlsFileUpld').value != null)
            formData.set('dtlsFileUpld', this.requestConfigForm.get('dtlsFileUpld').value);

         
          if (this.uploadedFilesList.length > 0) {
            this.uploadedFilesList.forEach((filesdet) => {
              filesdet.files.forEach((files, index) => {
                formData.set('conversionreqattachfile' + index + '*' + files.filetype + "*" + filesdet.productid, files);
              });
            });
          }



          if (data.productdetails.length > 0) {
            data.productdetails.forEach(filedetails => {
              filedetails.productfiledetails.forEach(fdetails => {
                if (filename == '')
                  filename = fdetails.conversionfiles;
                else
                  filename = filename + ':' + fdetails.conversionfiles;
              });              
            });
          }

          if (this.requestConfigForm.get('attachtemplatefile').value != null) {
            formData.set('attachtemplatefile', this.requestConfigForm.get('attachtemplatefile').value);
          }
          var s = this.databases.filter(e => e.databaseid == this.dbid);
          formData.append('filenamefromcomponent', filename);
          formData.append('dbname', s[0].database);
          formData.append('requestdetailid', this.requestDetails[0].requesttype + ':' + this.requestdetailid.toString());
          formData.append('type', 'edit');
          this.requestConfigService.PostFile(formData).subscribe(
            (res) => {
             if (res.body != 0) {

              }
            }, error => {
              this.SpinnerService.hide();
              this.toastr.error("Error while uploading File  during editing");
            });
          this.InitializeControls();
          this.selectedProducts = [];
          // (<FormArray>this.requestConfigForm.get('productdetails')).clear();
          this.requestConfigForm.controls['businessunit'].setValue(0);
          this.requestConfigForm.controls['dbid'].setValue(this.defaultbindingdbid);
          this.requestConfigForm.get('product').setValue([]);
          $.each($("div#requestConfigparentdiv input[type=checkbox]"), function (a, b) {
            $(this).prop("checked", false)

          })
          this.requestinfoshow = false; this.otherCites = false; this.documentInfo = false; this.queryDetails = false; this.details = false; this.conversionInfo = false;
          this.downloadInstrshow = false;
          this.proceedconversion = false;
          this.listofurlfromtemplate = [];
          this.backToRequestDashboard();

          // this.router.navigate(['/home/requestdashboard'])

        }
      }, err => {
        this.SpinnerService.hide();
        this.toastr.error('not able to update the request data')

      })
    }
  }

  //Code for events
  selectRequestType(event) {


    switch (event.currentTarget.id) {
      case 'courtOpenionReqChk':
        if (event.currentTarget.checked) {
          this.requestinfoshow = true;
          this.otherCites = true;
          this.documentInfo = true
          this.requestinfoContent = true;
          this.otherCitesContent = true;
          this.documentInfoContent = true;
          this.conversionInfo = false;
          if ($('#conversionReqChk').is(':checked'))
            this.conversionInfo = true;

        }
        else if (event.currentTarget.checked === false) {



          this.otherCites = false;
          this.documentInfo = false;


        }
        break;
      case 'researchGroupReqChk':
        if (event.currentTarget.checked) {
          this.requestinfoshow = true;
          this.details = true;
          this.requestinfoContent = true;
          this.detailsContent = true;
          this.costcenter = true;
          this.costlimitations = true;
          this.conversionInfo = false;
          if ($('#conversionReqChk').is(':checked'))
            this.conversionInfo = true;
        }
        else if (event.currentTarget.checked === false) {

          if ($("#researchGroupReqChk").prop('checked') || $("#informationReqChk").prop('checked')) {
            this.details = true;

          }
          else {
            this.details = false;
          }

          this.costcenter = false;

        }
        break;

      case 'informationReqChk':
        if (event.currentTarget.checked) {
          this.requestinfoshow = true; this.queryDetails = true; this.details = true;
          this.requestinfoContent = true; this.queryDetails = true; this.subject = true;
          this.filename = true;
          this.costlimitations = true;
          this.conversionInfo = false;
          if ($('#conversionReqChk').is(':checked'))
            this.conversionInfo = true;
        }
        else if (event.currentTarget.checked === false) {
         
          if ($("#researchGroupReqChk").prop('checked') || $("#informationReqChk").prop('checked')) {
            this.details = true;

          }
          else {
            this.details = false;
          }
          this.queryDetails = false; this.subject = false;
          this.requestConfigForm.patchValue({
            dtlsFileUpld: null
          });
        }
        break;
      case 'internetDownloadReqChk':
        if (event.currentTarget.checked) {
          this.requestinfoshow = true; this.downloadInstrshow = true;
          this.requestinfoContent = true; this.downloadInstrContent = true;
          this.conversionInfo = false;
         
          if ($('#conversionReqChk').is(':checked'))
            this.conversionInfo = true;

        }
        else if (event.currentTarget.checked === false) {

          this.downloadInstrshow = false;

          this.listofurlfromtemplate = [];
          this.requestConfigForm.patchValue({
            attachtemplatefile: null
          });

        }
        break;
      case 'conversionReqChk':
        if (event.currentTarget.checked) {          
          //if (this.selectedProducts.length > 0) {
          this.conversionInfo = true;
          // this.selectedProducts = [];

          // }

          if (this.selectedProducts.length > 0) {

            const myFactory = this.resolver.resolveComponentFactory(ProductdetailsComponent);
            this.selectedProducts.forEach(product => {
              var id = product.productid;
              var i = 0
              var selectproduct = this.products.find(item => item.productid === product.productid);
              var dirpath = selectproduct.dirpath;
              var productname = selectproduct.product;


              this.entry.forEach(container => {
                let containerid = container.viewContainerRef.element.nativeElement.id;
                const myRef = this.entry.toArray()[i].viewContainerRef.createComponent(myFactory, product.productid);
                this.entry.toArray()[i].viewContainerRef.element.nativeElement.id = product.productid;
                myRef.instance['productid'] = product.productid;
                myRef.instance['productname'] = productname;
                myRef.instance['directorypath'] = dirpath;
                myRef.instance['productmodel'] = selectproduct;
                myRef.instance['proceedconversion'] = this.proceedconversion;
                myRef.instance['internetdownloadproceedconversion'] = this.internetdownloadproceedconversion;
                myRef.instance['fromForm'] = this.fromForm;
                myRef.instance['formattachfile'] = this.attachedFileList;
                myRef.instance['redirectmodeforproduct'] = this.redirectmodeforproduct;
                var s = this.databases.filter(e => e.databaseid == this.dbid)
                if (s.length > 0) {
                  myRef.instance['dbname'] = s[0].database;
                }
                myRef.instance['requestid'] = this.requestdetailid;
              });

            });
          }


        }
        else if (event.currentTarget.checked === false) {

          this.conversionDocUpload = false;
          this.conversionInfo = false;
          // this.selectedProducts = [];
          this.productclear();


        }


    }


    var len = $("div#typeofrequest  input[type=checkbox]:checked").length;
    if (len > 0)
      this.requestinfoshow = true;
    else
      this.requestinfoshow = false;



    if ($('#courtOpenionReqChk').is(':checked') || $('#conversionReqChk').is(':checked')) {
      this.reqreport = true;
      this.reqparagraph = true;
      this.reqprodformat = true;
      this.reqprodname = true;

    }
    else {
      this.reqreport = false;
      this.reqparagraph = false;
      this.reqprodformat = false;
      this.reqprodname = false;

    }

    if ($('#researchGroupReqChk').is(':checked')) {
      this.reqcostcenter = true;
      this.reqprodgroup = true;
    }
    else {
      this.reqcostcenter = false;
      this.reqprodgroup = false;
    }






  }

  RequestConfigAcr(type) {

    if (type === 'requestinfo') {

      this.requestinfoContent = !this.requestinfoContent
      //this.requestinfoshow = !this.requestinfoshow;
    }


    if (type === 'downloadinstruction') {

      // this.downloadInstrshow = !this.downloadInstrshow;
      this.downloadInstrContent = !this.downloadInstrContent

    }

    if (type === 'documentinfo') {

      //this.documentInfo = !this.documentInfo;
      this.documentInfoContent = !this.documentInfoContent
    }
    if (type === 'othercites') {

      // this.otherCites = !this.otherCites;
      this.otherCitesContent = !this.otherCitesContent
    }
    if (type === 'details') {
      //this.details = false
      //this.details = !this.details;
      this.detailsContent = !this.detailsContent
    }
    if (type === 'querydetails') {
      this.queryDetailsContent = !this.queryDetailsContent
    }
    if (type === 'conversioninfo') {
      // this.conversionInfo = false
      // this.conversionInfo = !this.conversionInfo;
      this.conversionInfoContent = !this.conversionInfoContent

    }
  }

  onItemSelect(data: Product) {

    if (this.operationType === 'update' && this.requestConfigForm.value.conversionrequeststatus) {
      this.selectedProducts = [];
      this.entry.forEach(container => {
        if (container.viewContainerRef['_embeddedViews'].length != 0) {
          for (let i = 0; i < container.viewContainerRef['_embeddedViews'].length; i++) {
            if (container.viewContainerRef['_embeddedViews'][i] != undefined) {
              container.viewContainerRef.remove(i);
            }
          }
        }

      });
    }

    if ($("#conversionReqChk").prop('checked')) {
      this.productname = data.product;
      this.conversionInfoContent = true;

      let existItem = this.selectedProducts.filter(item => item.productid === data.productid);
      if (existItem.length === 0) {
        this.selectedProducts.push(data)
      }


      var dirpathrecord = this.products.find(item => item.productid === data.productid);
      var dirpath = dirpathrecord.dirpath;

      var i = 0;

      const myFactory = this.resolver.resolveComponentFactory(ProductdetailsComponent);
      this.entry.forEach(container => {
        let containerid = container.viewContainerRef.element.nativeElement.id;
        const myRef = this.entry.toArray()[i].viewContainerRef.createComponent(myFactory);
        this.entry.toArray()[i].viewContainerRef.element.nativeElement.id = data.productid;
        myRef.instance['productid'] = data.productid;
        myRef.instance['productname'] = data.product;
        myRef.instance['directorypath'] = dirpath;
        myRef.instance['productmodel'] = dirpathrecord;
        myRef.instance['proceedconversion'] = this.proceedconversion;
        myRef.instance['internetdownloadproceedconversion'] = this.internetdownloadproceedconversion;
        myRef.instance['fromForm'] = this.fromForm;
        myRef.instance['formattachfile'] = this.attachedFileList;
        myRef.instance['redirectmodeforproduct'] = this.redirectmodeforproduct;
        var s = this.databases.filter(e => e.databaseid == this.dbid)
        if (s.length > 0) {
          myRef.instance['dbname'] = s[0].database;
        }
        myRef.instance['requestid'] = this.requestdetailid;
        if (this.operationType === 'update' && this.requestConfigForm.value.conversionrequeststatus) {
          myRef.instance['operation'] = 'edit';
          myRef.instance['viewrequest'] = this.viewrequest;
          myRef.instance['productdetailsedit'] = this.requestDetails;
        }
      });

    }

    this.patchEmailIdByProducts();
    if (this.requestConfigForm.value.product.length <= 1) {
      let product = this.mainProductList.filter(x => x.productid == data.productid);
      let businessUnit;
      if (product.length > 0) {
        businessUnit = this.mainBusinessUnitList.filter(x => x.businessunitid == product[0].businessunitid);
        let productValues = this.mainProductList.filter(x => x.businessunitid == businessUnit[0].businessunitid);
        this.requestConfigForm.patchValue({
          businessunit: businessUnit[0].businessunitid
        });
        this.businessUnits = businessUnit;
        this.products = productValues;
      }
    }
    if (this.requestConfigForm.value.conversionrequeststatus && !this.proceedconversion) {
      this.samefileforallChange(this.requestConfigForm.value.samefileforall);
      this.getproductcomponentlist();
    }
  }

  onItemDeSelect(data: Product) {


    if (this.selectedProducts.find(x => x.productid == data.productid)) {
      this.selectedProducts.splice(this.selectedProducts.findIndex(x => x.productid == data.productid), 1);
    }

    this.entry.forEach(container => {
      if (container.viewContainerRef['_embeddedViews'].length != 0) {
        for (let i = 0; i < container.viewContainerRef['_embeddedViews'].length; i++) {
          if (container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.productid == data.productid) {
            container.viewContainerRef.remove(i);
          }
        }
      }

    });
    this.patchEmailIdByProducts();
    let formValue = this.requestConfigForm.value;
    if (formValue.product.length == 0) {
      this.products = this.mainProductList;
      this.businessUnits = this.mainBusinessUnitList;
      this.requestConfigForm.patchValue({
        product: [],
        businessunit: 0
      });
    }

  }

  onItemDeSelectAll(data: any) {


    this.conversionInfoContent = false;
    this.selectedProducts = [];
    this.dirPaths = [];
    this.products = this.mainProductList;
    this.businessUnits = this.mainBusinessUnitList;
    this.requestConfigForm.patchValue({
      product: [],
      businessunit: 0
    });
    this.productclear();
    this.patchEmailIdByProducts();
  }

  onItemSelectAll(data: any) {

    if ($("#conversionReqChk").prop('checked')) {
      this.conversionInfo = true
    }

    ///this.onItemDeSelectAll(data);


    const myFactory = this.resolver.resolveComponentFactory(ProductdetailsComponent);
    data.forEach(product => {
      var id = product.productid;
      var i = 0
      var dirpathrecord = this.products.find(item => item.productid === product.productid);
      var dirpath = dirpathrecord.dirpath;

      this.entry.forEach(container => {
        let containerid = container.viewContainerRef.element.nativeElement.id;
        const myRef = this.entry.toArray()[i].viewContainerRef.createComponent(myFactory, data.productid);
        this.entry.toArray()[i].viewContainerRef.element.nativeElement.id = product.productid;
        myRef.instance['productid'] = product.productid;
        myRef.instance['productname'] = product.product;
        myRef.instance['directorypath'] = dirpath;
        myRef.instance['productmodel'] = dirpathrecord;
        myRef.instance['proceedconversion'] = this.proceedconversion;
        myRef.instance['internetdownloadproceedconversion'] = this.internetdownloadproceedconversion;
        myRef.instance['fromForm'] = this.fromForm;
        myRef.instance['formattachfile'] = this.attachedFileList;
        myRef.instance['redirectmodeforproduct'] = this.redirectmodeforproduct;
        var s = this.databases.filter(e => e.databaseid == this.dbid)
        if (s.length > 0) {
          myRef.instance['dbname'] = s[0].database;
        }
        myRef.instance['requestid'] = this.requestdetailid;
      });

    });

    data.forEach(obj => {
      let existItem = this.selectedProducts.filter(item => item.productid === data.productid);
      if (existItem.length === 0) {
        this.selectedProducts.push(obj)
      }
    });
    this.patchEmailIdByProducts();
    if (this.requestConfigForm.value.conversionrequeststatus && !this.proceedconversion) {
      this.samefileforallChange(this.requestConfigForm.value.samefileforall);
      this.getproductcomponentlist();
    }
  }

  desiredCompDateChange(event, datectrlid, id, cntrlname, index?) {

    var todayDate = this.datePipe.transform(this.bsInlineValue, "dd/MM/yyyy");
    //console.log(a)
    var selDate = this.datePipe.transform(event, "dd/MM/yyyy");
    if (todayDate === selDate) {
      if (cntrlname == "datecontrollerproduct") {
        if ($('#' + id + index).prop('checked') === false) {
          this.showPopUp(event, datectrlid + index, id + index, cntrlname)
        }
      }
      else {
        if ($('#' + id).prop('checked') === false) {
          this.showPopUp(event, datectrlid, id, cntrlname)
        }
      }
    }
    else {
      if (cntrlname == "datecontrollerproduct") {
        $('#' + id + index).prop('checked', false)
      }
      else {
        this.requestConfigForm.controls[id].setValue(0);
        $('#' + id).prop('checked', false);
        this.noOfHoursValueSet(id);
      }
    }

  }

  samedaychange(event, datectrlid, id, cntrlname, index?) {
    //console.log(this.desiredCompDate)

    //;
    if (event.currentTarget.checked) {
      if (cntrlname == "checkboxcontrollerproduct") {
        this.showPopUp(event, datectrlid + index, id + index, cntrlname);
      }
      else {
        this.showPopUp(event, datectrlid, id, cntrlname);
      }

    }
    else {
      //this.requestConfigForm.controls[datectrlid].setValue(null);
      if (cntrlname == "checkboxcontrollerproduct") {
        $('#' + datectrlid + index).val(null);
      }
      else {
        this.requestConfigForm.controls[datectrlid].setValue(null);
        this.noOfHoursValueSet(id);
      }
    }

  }

  showPopUp(event, datectrlid, id, cntrlname) {
    //let showpopup = this.dialogService.addDialog(CommondialogComponent,
     // {
      //  title: 'Please Confirm',
      //  message: 'Same day turnaround will incur additional cost. Are you sure you want to continue?',
      //  hclass: 'modelsuccess',
      //  oktext: 'Yes',
      //  canceltext: 'No',
      //  okshow: true,
      //  cancelshow: true
      //}).subscribe((isConfirmed) => {
        if (cntrlname == 'datecontroller' || event.currentTarget.checked) {
          if (cntrlname === 'datecontroller') {
            $('#' + id).prop('checked', true);
            this.requestConfigForm.controls[id].setValue(true);
          }
          if (cntrlname === 'datecontrollerproduct') {
            $('#' + id).prop('checked', true)
          }
          if (cntrlname === 'checkboxcontroller') {

            this.requestConfigForm.controls[datectrlid].setValue(this.bsInlineValue);
            this.requestConfigForm.controls[id].setValue(true);
          }
          if (cntrlname === 'checkboxcontrollerproduct') {
            $('#' + datectrlid).val(this.datePipe.transform(this.bsInlineValue, "MM/dd/yyyy"));

          }
          return

        }
        else {
          if (cntrlname === 'datecontroller') {
            this.requestConfigForm.controls[datectrlid].setValue(null);
            this.requestConfigForm.controls[id].setValue(false);
          }
          if (cntrlname === 'datecontrollerproduct') {
            $('#' + datectrlid).val(null);
          }
          if (cntrlname === 'checkboxcontroller') {
            $('#' + id).prop('checked', false);
            this.requestConfigForm.controls[id].setValue(false);
          }
          if (cntrlname === 'checkboxcontrollerproduct') {
            $('#' + id).prop('checked', false)
          }
        }

      //});
  }

  loadFileDetails() {
    if (this.formConfigId == undefined || this.formConfigId == 0) {
      this.formdashboardservice.getFormConfig().subscribe((res) => {
        let formconfigList = res;
        var s = formconfigList.filter(e => e.formconfigname.toLowerCase() == this.formName.toLowerCase());
        if (s.length != 0) {
          this.formConfigId = s[0].formconfigid;
          this.getfileDetails();
        }
      });
    }
    else {
      this.getfileDetails();
    }
  }

  getfileDetails() {
    let dbValue = this.databases.find(x => x.databaseid == this.dbid);
    let databaseName = dbValue.database;
    // let database = this.dbid + '*' + databaseName;
    if (databaseName.trim() == 'Non Case Law') {
      this.attachedFileList = [];
      this.formRenderService.GetNonCaseLawFileNames(databaseName, this.formConfigId.toString(), this.documentId.toString())
        .subscribe(res => {
          if (res != null && res != undefined) {
            if (res.fileNames.length > 0) {
              res.fileNames.forEach((element, i) => {
                this.attachedFileList.push({
                  filenumber: i + 1, filename: element
                });
              });
            }
          }
        }, err => {
          this.attachedFileList = [];
        });
    } else {
      var _activeformconfigdetails = this.formConfigId + '*' + this.documentId;
      this.formRenderService.getFormRenderDocumentDetails(_activeformconfigdetails).subscribe(
        (res) => {
          if (res != undefined && res != null && res.length != 0 && (JSON.parse(res[0].j) != null)) {
            var s = JSON.parse(res[0].j);
            var _headers = Object.keys(s[0]);
            _headers.forEach(i => {
              if (i.toLowerCase().startsWith('file') && !i.toLowerCase().endsWith('size')) {
                var txt = s[0][i].split(';');
                if (txt.length != 0) {
                  for (var k = 0; k < txt.length; k++) {
                    this.attachedFileList.push({
                      filenumber: k + 1, filename: txt[k]
                    });
                  }
                }
              }
            });
          }
        });
    }
  }

  cancelOperation() {
    if (this.operationType === 'update') {
      this.router.navigate(['/home/requestdashboard'])
    }
    else {
      this.requestConfigForm.reset();
      this.InitializeControls();
      this.conversionInfo = false
      this.selectedProducts = [];
      this.dirPaths = [];
      this.listofurlfromtemplate = [];
      //$("#conversioninfoContentDiv").remove();
      this.requestinfoshow = false
      this.downloadInstrshow = false
      this.documentInfo = false
      this.otherCites = false
      this.details = false
      this.queryDetails = false
      this.conversionDocUpload = false
      this.productclear();
    }
  }

  //request status update
  statusupdate(status) {
    //var filecheck = this.requestConfigForm.get('conversionupload').value === ''
    if ((status == 5 && (this.finaluploadfilename == '' && (this.finaluploadfilenameedit == '' || this.finaluploadfilenameedit == null))) && (status == 5 && this.uploadedFilesList.length == 0)) {
      this.toastr.error('Please upload the file to complete the request');
      return;
    }

    if (status == 4 && this.requestConfigForm.controls['containsgraphics'].value == true && ((this.finaluploadfilename == '' && (this.finaluploadfilenameedit == '' || this.finaluploadfilenameedit == null)) && this.uploadedFilesList.length == 0)) {
      this.toastr.error('Contains graphics should be selected when file is uploaded');
      return;
    }
    if (status == 5 && this.requestConfigForm.controls['containsgraphics'].value == true && ((this.finaluploadfilename == '' && (this.finaluploadfilenameedit == '' || this.finaluploadfilenameedit == null)) && this.uploadedFilesList.length == 0)) {
      this.toastr.error('Please upload the file for graphics select');
      return;
    }

    if (status == 5 || status == 4) {
      this.SpinnerService.show()
      const formData = new FormData();

      formData.set('conversionFile', this.requestConfigForm.get('conversionFile').value);

      if (this.requesttypeid == 5)
      {        
        if (this.uploadedFilesList.length > 0)
        {
          this.uploadedFilesList.forEach((files, index) => {
            this.mappedfilesList.forEach((filesmapped) => {
              if (filesmapped.mappedfile == files.name)
                // formData.set('conversionFile' + index + '*' + filesmapped.name, files);
                formData.set('conversionFile' + index + '*' + filesmapped.name + "*" + filesmapped.filetype, files);
             
            });
            
            if (files.filetype == 'forSupporting')
              formData.set('conversionFile' + index + '*' + files.name + "*" + files.filetype, files);
      
         });
        }
       }

      var s = this.databases.filter(e => e.databaseid == this.dbid)
      formData.append('requeststatus', status);
      formData.append('dbname', s[0].database);
      formData.append('requestdetailid', this.requestDetails[0].requesttype + ':' + this.requestdetailid.toString());
      formData.append('type', 'Finaloutput');
      this.requestConfigService.PostFile(formData).subscribe(
        (res) => {
          if (res.body != 0) {
            this.requeststatus.requestdetailid = this.requestdetailid;
            this.requeststatus.requesttypeid = this.requesttypeid;
            this.requeststatus.active = 1;
            this.requeststatus.statusid = status;
            this.requeststatus.createdby = this.userid;
            var uploadedfilename = '';
            if (this.requesttypeid == 5) {
              if (this.mappedfilesList.length > 0) {
                this.mappedfilesList.forEach((files) => {
                  if (uploadedfilename == '') {
                    uploadedfilename = files.mappedfile+':'+files.id;
                  }
                  else {
                    uploadedfilename = uploadedfilename + '/' + files.mappedfile + ':' + files.id;
                  }
                });
              }
              this.requeststatus.finalupload = uploadedfilename.replace(/[']/g, "''");
            }
            else {
              this.requeststatus.finalupload = this.finaluploadfilename.replace(/[']/g, "''");
            }
            var supportfilename = "";
            if (this.requesttypeid == 5) {
              if (this.supportingFileList.length > 0) {
                this.supportingFileList.forEach(supporting => {
                  //if (supporting.active == 1) {

                  if (supportfilename == '')
                    supportfilename = supporting.name;
                  else
                    supportfilename = supportfilename + ':' + supporting.name;
                  // }
                });

              }
            }
            this.requeststatus.finaluploadsupportingfiles = supportfilename;

            this.requeststatus.containsgraphics = this.requestConfigForm.controls['containsgraphics'].value ? 1 : 0;
            //this.requeststatus.finalupload = this.finaluploadfilename;//.replace(/\s/g, '_').replace(/[%<>/\:*?&";|]/g, '');
            this.requestdashboardservice.Post(this.requeststatus).subscribe(
              (res) => {
                if (res.body != 0) {
                  this.SpinnerService.hide();                 
                  this.toastr.success("Status Updated Successfully");
                  this.router.navigate(['/home/requestdashboard']);
                }
              }, error => {
                this.SpinnerService.hide();
                this.toastr.error("Error while updating request status");
              });
          }
        }, error => {
          this.SpinnerService.hide();
          this.toastr.error("Error while uploading output File");
        });
    }
    else {
      this.SpinnerService.show();
      this.requeststatus.requestdetailid = this.requestdetailid;
      this.requeststatus.requesttypeid = this.requesttypeid;
      this.requeststatus.active = 1;
      this.requeststatus.statusid = status;
      this.requeststatus.createdby = this.userid;
      this.requeststatus.finalupload = this.finaluploadfilename;

      let validate = true;
      if (status == 16) {
        this.isnoupdatemailsend = true;
        validate = this.postRequestConfig(this.requestConfigForm.value);
      }

      if (!validate) {
        this.SpinnerService.hide();
        return;
      } else {
        this.requestdashboardservice.Post(this.requeststatus).subscribe(
          (res) => {
            if (res.body != 0) {
              this.SpinnerService.hide();
              this.toastr.success("Status Updated Successfully");
              this.router.navigate(['/home/requestdashboard']);
            }
          }, error => {
            this.SpinnerService.hide();
            this.toastr.error("Error while updating request status");
          });
      }


    }
  }


  fileDownload(filename) {
    this.SpinnerService.show();
    var s = this.databases.filter(e => e.databaseid == this.dbid)
    if (s != undefined && s != null && s.length != 0) {

      let fileData: any = [];
      fileData.push({
        'documentId': this.documentId, 'dbName': s[0].database, 'formConfigId': this.formConfigId, 'fileName': filename
      })
      this.requestConfigService.DownloadFormFile(fileData[0]).subscribe(res => {
        var content = res.body.file;
        let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
        saveAs(objectURL, filename);
        this.SpinnerService.hide();
      },
        error => {
          this.toastr.error('File not found');
          this.SpinnerService.hide();
        });


    }
  }


  fileDownloadrequest(filename, type) {
    this.SpinnerService.show();
    var s = this.databases.filter(e => e.databaseid == this.dbid)
    if (s != undefined && s != null && s.length != 0) {

      let requestData: any = [];
      requestData.push({
        'requesttype': this.requestDetails[0].requesttype, 'dbname': s[0].database, 'requestid': this.requestdetailid, 'fileName': filename, 'type': type
      });
      let a = filename.split(/(?<=\.[a-z]+):/g);
      if (a.length > 1) {
        requestData[0].fileName = this.requestDetails[0].requesttype + '_' + this.requestdetailid;
        filename = requestData[0].fileName;
        this.requestConfigService.DownloadFileRequestWithSpecialCharactersasZIP(requestData[0]).subscribe(res => {
          var content = res.body.file;
          let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
          saveAs(objectURL, filename + '.zip');
          this.SpinnerService.hide();
        },
          error => {
            this.toastr.error('File not found');
            this.SpinnerService.hide();
          });

      } else {
        this.requestConfigService.DownloadFileRequestWithSpecialCharacters(requestData[0]).subscribe(res => {
          var content = res.body.file;
          let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
          saveAs(objectURL, filename);
          this.SpinnerService.hide();
        },
          error => {
            this.toastr.error('File not found');
            this.SpinnerService.hide();
          });

      }
    }
  }
  ngAfterViewChecked() {

  }

  onFileSelect(fileInput: any) {
    if (fileInput.target.files.length > 0) {
      const file = fileInput.target.files[0];
      this.finaluploadfilename = file.name;
      this.requestConfigForm.get('conversionFile').setValue(file);
    }

  }

  onFileSelectcreate(fileInput: any) {
    var exeFileExists=false; var fileType='';
    if (fileInput.target.files.length > 0) {
      const file = fileInput.target.files[0];
      this.attachfileName = file.name;
      var index=  file.name.lastIndexOf('.'); 
      fileType= file.name.substring(index+1)
      var exeExists = this.executableFileTypes.filter(e=>e.type.toLowerCase()===fileType.toString().toLowerCase());
       if(exeExists.length>0){
        this.toastr.error( fileType+' files are not allowed to upload');
    $('#dtlsFileUpld').val('');
    return;
       } else{
        this.requestConfigForm.get('dtlsFileUpld').setValue(file);
       }
      
    }

  }

  onFileSelectconversioncreate(fileInput: any) {

    if (fileInput.target.files.length > 0) {
      const file = fileInput.target.files[0];
      this.attachconversionfileName = file.name;
      this.requestConfigForm.get('conversionreqattachfile').setValue(file);
    }

  }

  async  getAllProducts() {
    await this.productsService.Get().toPromise().then(res => {
      this.allproducts = res;
      this.mainProductList = JSON.parse(JSON.stringify(res.filter(p => p.active == 1)));
      this.products = this.allproducts.filter(p => p.active == 1)
    }, error => {
      this.toastr.error('Unable to get product data');
    })
  }

  backToRequestDashboard() {
    if (this.selectedReqType != undefined && this.selectedReqType != null) {
      let queryParams = {};
      const navigationExtras: NavigationExtras = {
        queryParams,
        state: {
          selectedDataBase: this.selectedDataBase,
          userType: this.userType,
          selectedColumnShow: this.selectedColumnShow,
          selectedReqType: this.selectedReqType,
          selectedPageNumber: this.selectedPageNumber,
          selectedItemsPerPage: this.selectedItemsPerPage,
          selectedSearchCondition: this.selectedSearchCondition,
          selectedSortCondition: this.selectedSortCondition,
          selectedSearchConditionList: this.selectedSearchConditionList
        }
      };
      this.router.navigate(['/home/requestdashboard'], navigationExtras);
    }
    else {
      this.router.navigate(['/home/requestdashboard']);
    }
  }
  getemailstring(externallist) {
    var externalToliststr = '';
    if (externallist) {
      // externalToliststr = externallist.replace(/,/g, ';');
      externallist.forEach((d) => {
        if (externalToliststr == '') {
          externalToliststr = d;
        } else {
          externalToliststr = externalToliststr + ';' + d;
        }
      });
    }
    return externalToliststr;
  }


  patchEmailIdByProducts() {
    let mailids = '';
    this.selectedProducts.forEach(element => {
      let filteredProducts = this.allproducts.filter(x => x.productid == element.productid);
      filteredProducts.forEach(innerElement => {
        let mailId = '';
        let exMailId = [];
        if (innerElement.notificationemailid != null) {
          mailId = this.framemailIds(JSON.parse(innerElement.notificationemailid));
        }
        if (innerElement.externalmailid != null) {
          exMailId = JSON.parse(innerElement.externalmailid);
        }
        if (mailids == '') {
          if (mailId != '') {
            mailids = mailId;
          }
        } else {
          if (mailId != '') {
            mailids = mailids + ';' + mailId;
          }
        }
        exMailId.forEach(element => {
          if (mailids == '') {
            mailids = element;
          } else {
            mailids = mailids + ';' + element;
          }
        });
      });
    });
    this.requestConfigForm.patchValue({
      alsonotify: mailids
    });
  }
  framemailIds(useridlist) {
    let mailids = '';
    let useridList = useridlist.mailto;
    if (useridList.length > 0) {
      useridList.forEach((d) => {
        this.usersList.forEach((data, ind) => {
          if (data.userid == d.userid) {
            if (mailids == '') {
              mailids = data.emailid;
            } else {
              mailids = mailids + ';' + data.emailid;
            }
          }
        });
      });
    }
    return mailids;
  }
  noOfHoursValueSet(id) {
    if (id == 'documentinfo_samedayturnaround') {
      this.requestConfigForm.controls['documentinfonumberofhours'].setValue(0);
    }
    if (id == 'detailssamedayturnaround') {
      this.requestConfigForm.controls['detailnumberofhours'].setValue(0);
    }
    if (id == 'querydetailssamedayturnaround') {
      this.requestConfigForm.controls['querydetailsnumberofhours'].setValue(0);
    }
  }
  sampleTemplateDownload() {
    let requestData: any = [];
    requestData.push({
      'requesttype': 'internetdownloadrequest', 'dbname': 'sampledocuments', 'requestid': null, 'fileName': 'sampletemplate.xlsx', 'type': null
    })

    this.requestConfigService.DownloadFileRequestWithSpecialCharacters(requestData[0]).subscribe(res => {
      var content = res.body.file;
      let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
      //saveAs(objectURL, 'sampletemplate.xlsx');
      saveAs(objectURL, 'sampletemplate_' + this.userid + '.xlsx');
      this.SpinnerService.hide();
    },
      error => {
        this.toastr.error('File not found');
        this.SpinnerService.hide();
      });
  }

  onFileChange(ev) {
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      const dataString = JSON.stringify(jsonData);
      if (jsonData != null) {
        // if (jsonData.Sheet1 != undefined) {
        let sheetName = '';
        Object.keys(jsonData).forEach((key, index) => {
          if (jsonData[key].length > 0) {
            let keys = Object.keys(jsonData[key][0]);
            let desiredfilename = keys.includes('desiredfilename');
            let urllocation = keys.includes('urllocation');
            if (desiredfilename && urllocation) {
              sheetName = key;
              return;
            }
          }
        });
        if (sheetName != '' && sheetName != null) {
          this.listofurlfromtemplate = jsonData[sheetName];
          this.templateuploadedname = file.name;
          this.requestConfigForm.patchValue({
            attachtemplatefile: file,
          });
        } else {
          this.toastr.warning('Invalid File Data. Please verify sample template');
          this.listofurlfromtemplate = [];
          this.templateuploadedname = '';
          this.requestConfigForm.patchValue({
            attachtemplatefile: null,
          });
        }
        // } else {
        //   this.toastr.warning('Invalid File Data. Please verify sample template');
        // }
      } else {
        this.toastr.warning('Please upload Excel file');
      }
    }
    reader.readAsBinaryString(file);
    $('#internetfileupload').val('');
  }
  UploadSourceFiles(template: TemplateRef<any>) {

    this.filesUploadModal = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");
  }


  fileChangeEvent(event) {
    var fileexist = false; var filename = ''; var filelist = [];var exeFileExists=false; var fileType='';

    for (var i = 0; i < event.target.files.length; i++) {
      var index=  event.target.files[i].name.lastIndexOf('.'); 
      fileType= event.target.files[i].name.substring(index+1)
        var exeExists = this.executableFileTypes.filter(e=>e.type.toLowerCase()===fileType.toString().toLowerCase());
       if(exeExists.length>0){
        exeFileExists=true;
       }
      }
  if(exeFileExists!=true){
    for (var i = 0; i < event.target.files.length; i++) {
      this.uploadedFilesList.forEach((upfile, ind2) => {
        if (event.target.files[i].name == upfile.name) {
          fileexist = true; filename = upfile.name;
        }

      })
    }

    if (fileexist != false) {
      this.toastr.warning('already a file Existed with name ' + filename);
      return;
    }

    if (fileexist == false) {
      for (var i = 0; i < event.target.files.length; i++) {
        event.target.files[i]['id'] = event.target.files[i].name + '_' + i;
        //event.target.files[i]['productid'] = this.productid;
        //event.target.files[i]['conversionrequestfiledetailid'] = 0;
        this.uploadedFilesList.push(event.target.files[i])
      }
    }
  }
  else{
    this.toastr.error( fileType+' files are not allowed to upload');
    $('#uploadconvertedfiles').val('');
    return;
    
  }
  }


  //RemoveFile(item, filetype) {
  //  this.uploadedFilesList = this.uploadedFilesList.filter(ufile => ufile.id != item.id);
  //  for (var i = 0; i < this.mytemplist.length; i++) {
  //    if (this.mytemplist[i].mappedno == item.sno) {
  //      this.mytemplist[i].mappedno = '';
  //      // delete this.mylist[i].mappedno; 
  //    }
  //  }
  //  this.uploadedFilesList.forEach((element, index) => {
  //    element.sno = index + 1;
  //  });

  //}
  RemoveFile(item, filetype) {
    this.uploadedFilesList = this.uploadedFilesList.filter(ufile => ufile.id != item.id);
    if (filetype == 'conversionfiles') {
      for (var i = 0; i < this.mytemplist.length; i++) {
        if (this.mytemplist[i].mappedno == item.sno) {
          this.mytemplist[i].mappedno = '';
          // delete this.mylist[i].mappedno; 
        }
      }
      this.conversionFileList = this.conversionFileList.filter(cfile => cfile.name !== item.name);
      this.conversionFileList.forEach((element, index) => {
        element.sno = index + 1;
      });
    }

    if (filetype = 'uploadfilelist')
      this.uploadedFilesList = this.uploadedFilesList.filter(ufile => ufile.id != item.id);
  }
  closeModal() {
   /// this.uploadedFilesList = [];
   // this.mappedfilesList = [];
    this.showuploadFile = true;
    this.showMappedList = false;
    this.showconversionfiles = false;
    if (this.isprimary) {
      if (this.mylist != null && this.mylist != undefined) {
        if (this.mylist.length > 0) {
          for (var i = 0; i < this.mylist.length; i++) {
            if (this.mylist[i].isprimary === 'true') {
              this.mytemplist = [];
              this.mytemplist.push(JSON.parse(JSON.stringify(this.mylist[i])));
            }
          }
        }
      }
    }
    else
      this.mytemplist = JSON.parse(JSON.stringify(this.mylist));
    this.filesUploadModal.hide();

  }

  mapfiles() {
    this.mappedfilesList = [];

    for (var i = 0; i < this.mytemplist.length; i++) {
      var mappedfile = this.uploadedFilesList.find(item => item.sno == this.mytemplist[i].mappedno)
      var a = this.mytemplist.filter(item => item.mappedno == this.mytemplist[i].mappedno);
      if (!mappedfile) {
        this.toastr.warning('please enter proper output file number for this source file ' + this.mytemplist[i].conversionfiles);
        return;
      }
      var filetype = mappedfile.name.substr(mappedfile.name.lastIndexOf('.') + 1)
      if (filetype == 'docx' || filetype == 'doc')
        filetype = 'word';
      if (filetype == 'xls ' || filetype == 'xlsx')
        filetype = 'excel';

      if (this.mytemplist[i].outputfilename != null) {
        if (this.mytemplist[i].outputfilename.toLowerCase() != filetype.toLowerCase()) {
          this.toastr.warning('please upload valid ouput file with desired output format ');
          return;
        }
      }
     
      if (a.length > 1) {
        this.toastr.warning('Same file mapped to more than one file ');
        return;
      }
      else {
        
        this.mappedfilesList.push({ id: this.mytemplist[i].conversionrequestfiledetailid, name: this.mytemplist[i].conversionfiles, mappedfile: mappedfile.name, filetype: mappedfile.filetype });
      }

    }

    this.showuploadFile = false;
    this.showconversionfiles = false;
    this.showMappedList = true;

  }

  completeMapping(data) {

    if (data == 'complete') {
      this.filesUploadModal.hide();
    }
    else if (data == 'back') {

      this.showuploadFile = false;
      this.showMappedList = false;
      this.showconversionfiles = true;
    }

  }
  getRequestName(element) {
    switch (element.requesttype) {
      case 1:
        return 'Court Opinion AGO Request';
        break;
      case 2:
        return 'Research Group Request';
        break;
      case 3:
        return 'Information Request';
        break;
      case 4:
        return 'Internet Download Request';
        break;
      case 5:
        return 'Conversion Request' + this.getProductName(element.productid);
        break;
    }
  }

  getProductName(productid) {
    let productDetails = this.allproducts.filter(x => x.productid == productid);
    if (productDetails.length > 0) {
      let productName = productDetails[0].product;
      return ' - ' + productName;
    } else {
      return '';
    }
  }


  getRelatedDocumentsList(relatedDocuments) {
    let relatedDocList = [];
    relatedDocuments.forEach(element => {
      element['requestname'] = this.getRequestName(element);
    });

    if (relatedDocuments != null && relatedDocuments.length > 0) {
      let index = relatedDocuments.findIndex(x => x.requestid == this.requestdetailid);
      relatedDocuments.splice(index, 1);
    }
    relatedDocList = relatedDocuments;
    return relatedDocList;

  }


  public onContextMenu($event: KeyboardEvent, item: any): void {
    this.contextMenuService.show.next({
      anchorElement: $event.target,
      // Optional - if unspecified, all context menu components will open
      // contextMenu: this.contextMenu,
      event: <any>$event,
      item: item,
    });
    $event.preventDefault();
    $event.stopPropagation();
  }

  changeRequest(request) {
    let queryParams = {};
    queryParams['requestid'] = this.enc.encryptUsingAES256(request.requestid.toString());
    queryParams['requesttypeid'] = this.enc.encryptUsingAES256(request.requesttype.toString());
    queryParams['redirectmode'] = this.enc.encryptUsingAES256('viewrequest');
    const navigationExtras: NavigationExtras = {
      queryParams,
      state: {}
    };
    // this.router.navigate(['/home/requestconfig'], navigationExtras);

    let url = this.router.createUrlTree(['/home/requestconfig'],
      { queryParams: queryParams });
    window.open('#' + url.toString(), '_blank')


    // this.requestConfigForm.reset();
    // this.InitializeControls();
    // this.conversionInfo = false
    // this.selectedProducts = [];
    // this.dirPaths = [];
    // this.requestinfoshow = false
    // this.downloadInstrshow = false
    // this.documentInfo = false
    // this.otherCites = false
    // this.details = false
    // this.queryDetails = false
    // this.conversionDocUpload = false
    // this.listofurlfromtemplate = [];
    // this.productclear();
    // this.ngOnInit();
  }
  businessUnitChange(event) {
    let splitEvent = event.split(': ');
    let businessUnitId = splitEvent[1];
    if (businessUnitId != 0) {
      this.products = this.mainProductList.filter(x => x.businessunitid == businessUnitId);
    } else {
      this.products = this.mainProductList;
      this.onItemDeSelectAll(event);
    }
  }


  checkConversionExist(data) {
    this.SpinnerService.show();

    this.requestConfigService.checkConversionExist(data).subscribe(res => {
    
      if (res.body.retval == ' ' && !res.body.retval.includes('conversionrequestexist')) {
        this.save(data);
      } else {
        this.SpinnerService.hide();
        if (res.body.retval.includes('conversionrequestexist')) {
          console.log('res.body.retval: ', res.body.retval);

          let response = res.body.retval;
          let splitIds = [];
          this.existIds = [];
          splitIds = response.split(':')[1].split(',');
          if (splitIds.length > 0) {
            this.existIds = splitIds.filter(x => x != '');

          }
          this.postData = JSON.stringify(data);
          this.openExistPopup(this.checkExistConversion);
        }
      }
    }, err => {
      this.SpinnerService.hide();
    });
  }


  redirect(id) {
    let queryParams = {};
    queryParams['requestid'] = this.enc.encryptUsingAES256(id.toString());
    queryParams['requesttypeid'] = this.enc.encryptUsingAES256(5);
    queryParams['redirectmode'] = this.enc.encryptUsingAES256('viewrequest');
    const navigationExtras: NavigationExtras = {
      queryParams,
    };
    // this.router.navigate(['/home/requestconfig'], navigationExtras);

    let url = this.router.createUrlTree(['/home/requestconfig'],
      { queryParams: queryParams });
    window.open('#' + url.toString(), '_blank')

  }



  openExistPopup(template: TemplateRef<any>) {
    this.popupModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");
  }

  confirmSave() {
    this.popupModalRef.hide();
    this.save(JSON.parse(this.postData));
  }

  //samefileforallChange(samefileforallvalue) {
  //  let uploadedfiles = [];
  //  let conversionfiles = [];
  //  let supportfiles = [];
  //  this.selectedProducts.forEach(selproduct => {
  //    // count = 0;
  //    this.entry.forEach(container => {
  //      let containerid = container.viewContainerRef.element.nativeElement.id;
  //      if (container.viewContainerRef !== undefined) {
  //        if (container.viewContainerRef['_embeddedViews'].length != 0) {
  //          for (let i = 1; i < container.viewContainerRef['_embeddedViews'].length; i++) {
  //            if (container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.productid == selproduct.productid) {
  //              container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['samefileforall'] = samefileforallvalue;
  //              container.viewContainerRef['_embeddedViews'][0].nodes[1].instance['emitsamefiles'] = samefileforallvalue;
  //            }
  //          }
  //        }
  //      }
  //      conversionfiles = container.viewContainerRef['_embeddedViews'][0].nodes[1].instance['conversionFileList'];
  //      supportfiles = container.viewContainerRef['_embeddedViews'][0].nodes[1].instance['supportingFileList'];
  //      uploadedfiles = container.viewContainerRef['_embeddedViews'][0].nodes[1].instance['uploadedFilesList'];

  //    });
  //  });
  //  if (uploadedfiles.length > 0 && samefileforallvalue) {
  //    this.selectedProducts.forEach(selproduct => {
  //      // count = 0;
  //      this.entry.forEach(container => {
  //        let containerid = container.viewContainerRef.element.nativeElement.id;
  //        if (container.viewContainerRef !== undefined) {
  //          if (container.viewContainerRef['_embeddedViews'].length != 0) {
  //            for (let i = 1; i < container.viewContainerRef['_embeddedViews'].length; i++) {
  //              if (container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.productid == selproduct.productid) {
  //                container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['conversionFileList'] = conversionfiles;
  //                container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['supportingFileList'] = supportfiles;
  //                container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['uploadedFilesList'] = uploadedfiles;
  //              }
  //            }
  //          }
  //        }
  //      });
  //    });
  //  }
  //}
  samefilechange(event, productid) {
    this.requestConfigForm.patchValue({
      samefileforall: event
    });
    this.fileuploadedproduct = productid;
    this.entry.forEach(container => {
      let containerid = container.viewContainerRef.element.nativeElement.id;
      if (container.viewContainerRef !== undefined) {
        if (container.viewContainerRef['_embeddedViews'].length != 0) {
          for (let i = 0; i < container.viewContainerRef['_embeddedViews'].length; i++) {
            // tslint:disable-next-line: max-line-length
            if (container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.productid == productid) {
              container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['emitsamefiles'] = event;
            } else {
              container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['samefileforall'] = event;
              container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['emitsamefiles'] = event;
              if (!event) {
                container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['conversionFileList'] = [];
                container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['supportingFileList'] = [];
                container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['uploadedFilesList'] = [];
              }
            }
          }
        }
      }
    });
  }



  samefileforallChange(samefileforallvalue) {
    let uploadedfiles = [];
    let conversionfiles = [];
    let supportfiles = [];

    let fileuploadedprt = this.selectedProducts.filter(x => x.productid == this.fileuploadedproduct);
    this.fileuploadedproduct = fileuploadedprt.length > 0 ? this.fileuploadedproduct : 0

    if (this.fileuploadedproduct > 0) {
      this.entry.forEach(container => {
        if (container.viewContainerRef !== undefined) {
          if (container.viewContainerRef['_embeddedViews'].length != 0) {

            for (let i = 0; i < container.viewContainerRef['_embeddedViews'].length; i++) {
              if (container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['productid'] != this.fileuploadedproduct) {
                container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['samefileforall'] = samefileforallvalue;
                // container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['emitsamefiles'] = samefileforallvalue;
                // container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['usesamevalueforall'] = samefileforallvalue;

                container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['emitsamefiles'] = !samefileforallvalue;
                container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['usesamevalueforall'] = !samefileforallvalue;
              }
            }

            for (let i = 0; i < container.viewContainerRef['_embeddedViews'].length; i++) {
              if (container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.productid == this.fileuploadedproduct) {
                conversionfiles = container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['conversionFileList'];
                supportfiles = container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['supportingFileList'];
                uploadedfiles = container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['uploadedFilesList'];
              }
            }

          }
        }
      });
    } else {

      this.selectedProducts.forEach(selproduct => {
        // count = 0;
        this.entry.forEach(container => {
          let containerid = container.viewContainerRef.element.nativeElement.id;
          if (container.viewContainerRef !== undefined) {
            if (container.viewContainerRef['_embeddedViews'].length != 0) {

              for (let i = 1; i < container.viewContainerRef['_embeddedViews'].length; i++) {
                // tslint:disable-next-line: max-line-length
                if (container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.productid == selproduct.productid) {
                  container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['samefileforall'] = samefileforallvalue;
                  container.viewContainerRef['_embeddedViews'][0].nodes[1].instance['emitsamefiles'] = samefileforallvalue;
                  container.viewContainerRef['_embeddedViews'][0].nodes[1].instance['usesamevalueforall'] = samefileforallvalue;
                  if (!samefileforallvalue) {
                    container.viewContainerRef['_embeddedViews'][0].nodes[1].instance['samefileforall'] = samefileforallvalue;
                  }
                }
              }

            }
          }
          conversionfiles = container.viewContainerRef['_embeddedViews'][0].nodes[1].instance['conversionFileList'];
          supportfiles = container.viewContainerRef['_embeddedViews'][0].nodes[1].instance['supportingFileList'];
          uploadedfiles = container.viewContainerRef['_embeddedViews'][0].nodes[1].instance['uploadedFilesList'];

        });
      });
    }


    if (uploadedfiles.length > 0 && samefileforallvalue) {
      this.selectedProducts.forEach(selproduct => {
        // count = 0;
        this.entry.forEach(container => {
          let containerid = container.viewContainerRef.element.nativeElement.id;
          if (container.viewContainerRef !== undefined) {
            if (container.viewContainerRef['_embeddedViews'].length != 0) {
              if (this.fileuploadedproduct > 0) {
                for (let i = 0; i < container.viewContainerRef['_embeddedViews'].length; i++) {
                  if (container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.productid != this.fileuploadedproduct) {
                    container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['conversionFileList'] = conversionfiles;
                    container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['supportingFileList'] = supportfiles;
                    container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['uploadedFilesList'] = uploadedfiles;
                  }
                }
              } else {
                for (let i = 1; i < container.viewContainerRef['_embeddedViews'].length; i++) {
                  if (container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.productid == selproduct.productid) {
                    container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['conversionFileList'] = conversionfiles;
                    container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['supportingFileList'] = supportfiles;
                    container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['uploadedFilesList'] = uploadedfiles;
                  }
                }
              }

            }
          }
        });
      });
    } else if (!samefileforallvalue) {
      this.selectedProducts.forEach(selproduct => {
        // count = 0;
        this.entry.forEach(container => {
          let containerid = container.viewContainerRef.element.nativeElement.id;
          if (container.viewContainerRef !== undefined) {
            if (container.viewContainerRef['_embeddedViews'].length != 0) {
              if (this.fileuploadedproduct > 0) {
                for (let i = 0; i < container.viewContainerRef['_embeddedViews'].length; i++) {
                  if (container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.productid != this.fileuploadedproduct) {
                    container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['conversionFileList'] = [];
                    container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['supportingFileList'] = [];
                    container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['uploadedFilesList'] = [];
                    container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['usesamevalueforall'] = samefileforallvalue;
                  }
                }
              } else {
                for (let i = 1; i < container.viewContainerRef['_embeddedViews'].length; i++) {
                  if (container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.productid == selproduct.productid) {
                    container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['conversionFileList'] = [];
                    container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['supportingFileList'] = [];
                    container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['uploadedFilesList'] = [];
                    container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['usesamevalueforall'] = samefileforallvalue;
                  }
                }
              }

              // container.viewContainerRef['_embeddedViews'][0].nodes[1].instance['usesamevalueforall'] = !samefileforallvalue;
            }
          }
        });
      });
    }

  }





  filetypechange(item, event) {
    for (var i = 0; i < this.uploadedFilesList.length; i++) {

      if (this.uploadedFilesList[i].name == item.name) {        
        this.uploadedFilesList[i]['filetype'] = event.currentTarget.value;
        if (this.uploadedFilesList[i]['filetype'] == 'forSupporting')
          this.uploadedFilesList[i]['sno'] = 0;
      }

    }


  }
  movefilestonext(data) {

    if (this.uploadedFilesList.length > 0) {
      var count = 0;

      if (data == 'next') {
        if (this.isprimary) {
          var res = this.uploadedFilesList.filter(e => e.filetype == 'forConversion');
          if (res.length > 1) {
            this.toastr.warning('please select only one  file for oneconversion ');
            return;
          }
        }


        this.uploadedFilesList.forEach(item => {
          if (!item.hasOwnProperty("filetype")) {
            count++;
          }
        });

        if (count == 0) {

          this.conversionFileList = this.uploadedFilesList.filter(item => item.filetype === 'forConversion');
          this.supportingFileList = this.uploadedFilesList.filter(item => item.filetype === 'forSupporting');
          if (this.conversionFileList.length > 0) {
            for (var i = 0; i < this.conversionFileList.length; i++) {
              this.conversionFileList[i]['sno'] = i + 1
            }

            this.showuploadFile = false;
            this.showconversionfiles = true;
          } else {
            this.toastr.warning('Please select atleast one conversion file');
          }
        }
        else {
          this.toastr.warning('please selece all files for conversion or supporting');
        }

      }
      else if (data == 'prev') {
        this.showuploadFile = true;
        this.showconversionfiles = false;
      }
    } else {
      this.toastr.warning('Please upload any file');
    }
  }
  getproductcomponentlist() {
    let length = 0;
    this.entry.forEach(container => {
      if (container.viewContainerRef !== undefined) {
        if (container.viewContainerRef['_embeddedViews'].length != 0) {
          length = container.viewContainerRef['_embeddedViews'].length;
          for (let i = 0; i < container.viewContainerRef['_embeddedViews'].length; i++) {
            container.viewContainerRef['_embeddedViews'][i].nodes[1].instance['productlistcount'] = length;
          }
        }
      }
    });
  }

  filenoexistvalidation(value, mode)  {
    if (this.requestConfigForm.value.conversionrequeststatus) {
      let productdetails = [];
      let uploadedFilesList = [];
      this.selectedProducts.forEach(selproduct => {
        // count = 0;
        this.entry.forEach(container => {
          let containerid = container.viewContainerRef.element.nativeElement.id;
          if (container.viewContainerRef !== undefined) {
            if (container.viewContainerRef['_embeddedViews'].length != 0) {
              for (let i = 0; i < container.viewContainerRef['_embeddedViews'].length; i++) {
                // tslint:disable-next-line: max-line-length
                if (container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.productid == selproduct.productid) {

                  productdetails.push(container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.getproductdetails());
                  let files = container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.getproductfiles();
                  uploadedFilesList.push({
                    files: files,
                    productid: selproduct.productid
                  });
                }
              }
            }
          }
        });
      });


      if (productdetails.length > 0) {
        for (var i = 0; i < uploadedFilesList.length; i++) {
          var conversionfileexist = uploadedFilesList[i].files.filter(d => d.filetype == 'forConversion');
          let activefiles = conversionfileexist.filter(x => x.active == 1);
          if (conversionfileexist.length == 0 || activefiles.length == 0) {

            // this.toastr.warning('Please upload atleast one conversion file for a product')
            // return false;

            let showpopup = this.dialogService.addDialog(CommondialogComponent,
              {
                title: 'Please Confirm',
                message: 'Source file does not exist. Are you sure want to proceed?',
                hclass: 'modelsuccess',
                oktext: 'Yes',
                canceltext: 'No',
                okshow: true,
                cancelshow: true

              }).subscribe((isConfirmed) => {
                if (isConfirmed) {
                  if (mode == 'update') {
                    this.postRequestConfig(value);
                  } else {
                    this.statusupdate(value);
                  }
                }
              });

          }
          else {
            if (mode == 'update') {
              this.postRequestConfig(value);
            } else {
              this.statusupdate(value);
            }
          }
        }
      }
      else {
        if (mode == 'update') {
          this.postRequestConfig(value);
        } else {
          this.statusupdate(value);
        }
      }
    } else {
      if (mode == 'update') {
        this.postRequestConfig(value);
      } else {
        this.statusupdate(value);
      }
    }

  }
  gotoform() {
    let dbValue = this.databases.find(x => x.databaseid == this.dbid);
    let databaseName = dbValue.database;
    let database = this.dbid + '*' + databaseName;
    let queryParams = {};
    queryParams['db'] = this.enc.encryptUsingAES256(this.dbid.toString());
    queryParams['formDB'] = this.enc.encryptUsingAES256(database.toString());
    queryParams['data'] = this.enc.encryptUsingAES256(this.documentId.toString());
    queryParams['formConfigId'] = this.enc.encryptUsingAES256(this.formConfigId.toString());
    queryParams['mode'] = this.enc.encryptUsingAES256('View');

    const navigationExtras: NavigationExtras = {
      queryParams
    };

    // this.router.navigate(['/home/formrender'], navigationExtras);
    let url = this.router.createUrlTree(['/home/formrender'], { queryParams: queryParams });
    window.open('#' + url.toString(), '_blank')
  }

}
